"use strict";

require("core-js/modules/es6.array.filter.js");
var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.small.js");
require("core-js/modules/es6.function.name.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _gridStyled = require("grid-styled");
var _get = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _backdrop = _interopRequireDefault(require("@gravity/backdrop"));
var _button = _interopRequireWildcard(require("@gravity/button"));
var _jsonMetadata = _interopRequireDefault(require("@gravity/json-metadata"));
var _price = _interopRequireDefault(require("@gravity/price"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _product = require("@nucleo/product");
var _CheckResaleAvailability = _interopRequireDefault(require("./CheckResaleAvailability"));
var _DateLabel = _interopRequireDefault(require("./DateLabel"));
var _MatchTeamDetail = _interopRequireDefault(require("./MatchTeamDetail"));
var _ProductActions = _interopRequireDefault(require("./ProductActions"));
var _ProductDate = _interopRequireDefault(require("./ProductDate"));
var _ProductDescription = _interopRequireDefault(require("./ProductDescription"));
var _ProductDescriptionIcon = _interopRequireDefault(require("./ProductDescriptionIcon"));
var _ProductHelper = _interopRequireDefault(require("./ProductHelper"));
var _ProductImage = _interopRequireDefault(require("./ProductImage"));
var _ProductIndicator = _interopRequireDefault(require("./ProductIndicator"));
var _ProductTitle = require("./ProductTitle");
var _utils2 = require("./utils");
var _jsxFileName = "/codebuild/output/src2736821109/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductLine.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9,
  _templateObject10,
  _templateObject11,
  _templateObject12,
  _templateObject13,
  _templateObject14,
  _templateObject15,
  _templateObject16,
  _templateObject17,
  _templateObject18,
  _templateObject19,
  _templateObject20,
  _templateObject21,
  _templateObject22,
  _templateObject23,
  _templateObject24,
  _templateObject25,
  _templateObject26,
  _templateObject27,
  _templateObject28,
  _templateObject29,
  _templateObject30,
  _this = void 0,
  _templateObject31,
  _templateObject32,
  _templateObject33;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_2qgp94n5nb() {
  var path = "/codebuild/output/src2736821109/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductLine.js";
  var hash = "73b9120b54d5a5ade454c347c207d2e6361458bd";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src2736821109/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductLine.js",
    statementMap: {
      "0": {
        start: {
          line: 45,
          column: 35
        },
        end: {
          line: 45,
          column: 57
        }
      },
      "1": {
        start: {
          line: 47,
          column: 16
        },
        end: {
          line: 101,
          column: 1
        }
      },
      "2": {
        start: {
          line: 49,
          column: 24
        },
        end: {
          line: 49,
          column: 76
        }
      },
      "3": {
        start: {
          line: 66,
          column: 32
        },
        end: {
          line: 66,
          column: 56
        }
      },
      "4": {
        start: {
          line: 71,
          column: 41
        },
        end: {
          line: 71,
          column: 74
        }
      },
      "5": {
        start: {
          line: 75,
          column: 32
        },
        end: {
          line: 75,
          column: 56
        }
      },
      "6": {
        start: {
          line: 103,
          column: 28
        },
        end: {
          line: 163,
          column: 1
        }
      },
      "7": {
        start: {
          line: 106,
          column: 6
        },
        end: {
          line: 106,
          column: 95
        }
      },
      "8": {
        start: {
          line: 133,
          column: 8
        },
        end: {
          line: 136,
          column: 9
        }
      },
      "9": {
        start: {
          line: 164,
          column: 25
        },
        end: {
          line: 173,
          column: 2
        }
      },
      "10": {
        start: {
          line: 174,
          column: 18
        },
        end: {
          line: 178,
          column: 1
        }
      },
      "11": {
        start: {
          line: 180,
          column: 21
        },
        end: {
          line: 186,
          column: 1
        }
      },
      "12": {
        start: {
          line: 188,
          column: 23
        },
        end: {
          line: 194,
          column: 1
        }
      },
      "13": {
        start: {
          line: 196,
          column: 19
        },
        end: {
          line: 213,
          column: 1
        }
      },
      "14": {
        start: {
          line: 215,
          column: 28
        },
        end: {
          line: 221,
          column: 1
        }
      },
      "15": {
        start: {
          line: 222,
          column: 21
        },
        end: {
          line: 246,
          column: 1
        }
      },
      "16": {
        start: {
          line: 228,
          column: 24
        },
        end: {
          line: 228,
          column: 42
        }
      },
      "17": {
        start: {
          line: 230,
          column: 26
        },
        end: {
          line: 230,
          column: 42
        }
      },
      "18": {
        start: {
          line: 238,
          column: 24
        },
        end: {
          line: 238,
          column: 40
        }
      },
      "19": {
        start: {
          line: 248,
          column: 27
        },
        end: {
          line: 271,
          column: 2
        }
      },
      "20": {
        start: {
          line: 253,
          column: 66
        },
        end: {
          line: 253,
          column: 77
        }
      },
      "21": {
        start: {
          line: 266,
          column: 67
        },
        end: {
          line: 266,
          column: 78
        }
      },
      "22": {
        start: {
          line: 273,
          column: 21
        },
        end: {
          line: 285,
          column: 2
        }
      },
      "23": {
        start: {
          line: 287,
          column: 20
        },
        end: {
          line: 311,
          column: 2
        }
      },
      "24": {
        start: {
          line: 290,
          column: 22
        },
        end: {
          line: 290,
          column: 33
        }
      },
      "25": {
        start: {
          line: 303,
          column: 24
        },
        end: {
          line: 303,
          column: 35
        }
      },
      "26": {
        start: {
          line: 313,
          column: 27
        },
        end: {
          line: 323,
          column: 1
        }
      },
      "27": {
        start: {
          line: 324,
          column: 33
        },
        end: {
          line: 328,
          column: 1
        }
      },
      "28": {
        start: {
          line: 330,
          column: 29
        },
        end: {
          line: 338,
          column: 1
        }
      },
      "29": {
        start: {
          line: 340,
          column: 34
        },
        end: {
          line: 348,
          column: 1
        }
      },
      "30": {
        start: {
          line: 350,
          column: 26
        },
        end: {
          line: 371,
          column: 1
        }
      },
      "31": {
        start: {
          line: 373,
          column: 23
        },
        end: {
          line: 406,
          column: 1
        }
      },
      "32": {
        start: {
          line: 375,
          column: 26
        },
        end: {
          line: 375,
          column: 84
        }
      },
      "33": {
        start: {
          line: 376,
          column: 19
        },
        end: {
          line: 376,
          column: 35
        }
      },
      "34": {
        start: {
          line: 378,
          column: 2
        },
        end: {
          line: 405,
          column: 4
        }
      },
      "35": {
        start: {
          line: 408,
          column: 0
        },
        end: {
          line: 416,
          column: 2
        }
      },
      "36": {
        start: {
          line: 418,
          column: 0
        },
        end: {
          line: 422,
          column: 2
        }
      },
      "37": {
        start: {
          line: 424,
          column: 36
        },
        end: {
          line: 430,
          column: 2
        }
      },
      "38": {
        start: {
          line: 432,
          column: 21
        },
        end: {
          line: 466,
          column: 1
        }
      },
      "39": {
        start: {
          line: 434,
          column: 4
        },
        end: {
          line: 464,
          column: 19
        }
      },
      "40": {
        start: {
          line: 468,
          column: 0
        },
        end: {
          line: 474,
          column: 2
        }
      },
      "41": {
        start: {
          line: 476,
          column: 0
        },
        end: {
          line: 479,
          column: 2
        }
      },
      "42": {
        start: {
          line: 481,
          column: 20
        },
        end: {
          line: 502,
          column: 1
        }
      },
      "43": {
        start: {
          line: 483,
          column: 4
        },
        end: {
          line: 500,
          column: 25
        }
      },
      "44": {
        start: {
          line: 504,
          column: 0
        },
        end: {
          line: 517,
          column: 2
        }
      },
      "45": {
        start: {
          line: 519,
          column: 0
        },
        end: {
          line: 524,
          column: 2
        }
      },
      "46": {
        start: {
          line: 527,
          column: 20
        },
        end: {
          line: 593,
          column: 1
        }
      },
      "47": {
        start: {
          line: 541,
          column: 28
        },
        end: {
          line: 547,
          column: 12
        }
      },
      "48": {
        start: {
          line: 542,
          column: 10
        },
        end: {
          line: 544,
          column: 11
        }
      },
      "49": {
        start: {
          line: 543,
          column: 12
        },
        end: {
          line: 543,
          column: 30
        }
      },
      "50": {
        start: {
          line: 546,
          column: 10
        },
        end: {
          line: 546,
          column: 58
        }
      },
      "51": {
        start: {
          line: 549,
          column: 8
        },
        end: {
          line: 566,
          column: 9
        }
      },
      "52": {
        start: {
          line: 550,
          column: 10
        },
        end: {
          line: 565,
          column: 12
        }
      },
      "53": {
        start: {
          line: 569,
          column: 10
        },
        end: {
          line: 579,
          column: 25
        }
      },
      "54": {
        start: {
          line: 582,
          column: 8
        },
        end: {
          line: 584,
          column: 9
        }
      },
      "55": {
        start: {
          line: 583,
          column: 10
        },
        end: {
          line: 583,
          column: 47
        }
      },
      "56": {
        start: {
          line: 585,
          column: 8
        },
        end: {
          line: 589,
          column: 10
        }
      },
      "57": {
        start: {
          line: 595,
          column: 0
        },
        end: {
          line: 610,
          column: 2
        }
      },
      "58": {
        start: {
          line: 612,
          column: 0
        },
        end: {
          line: 624,
          column: 2
        }
      },
      "59": {
        start: {
          line: 626,
          column: 21
        },
        end: {
          line: 628,
          column: 1
        }
      },
      "60": {
        start: {
          line: 629,
          column: 23
        },
        end: {
          line: 632,
          column: 1
        }
      },
      "61": {
        start: {
          line: 634,
          column: 32
        },
        end: {
          line: 638,
          column: 1
        }
      },
      "62": {
        start: {
          line: 635,
          column: 2
        },
        end: {
          line: 635,
          column: 41
        }
      },
      "63": {
        start: {
          line: 635,
          column: 19
        },
        end: {
          line: 635,
          column: 41
        }
      },
      "64": {
        start: {
          line: 636,
          column: 2
        },
        end: {
          line: 636,
          column: 35
        }
      },
      "65": {
        start: {
          line: 636,
          column: 16
        },
        end: {
          line: 636,
          column: 35
        }
      },
      "66": {
        start: {
          line: 637,
          column: 2
        },
        end: {
          line: 637,
          column: 20
        }
      },
      "67": {
        start: {
          line: 640,
          column: 32
        },
        end: {
          line: 691,
          column: 1
        }
      },
      "68": {
        start: {
          line: 641,
          column: 30
        },
        end: {
          line: 641,
          column: 35
        }
      },
      "69": {
        start: {
          line: 642,
          column: 18
        },
        end: {
          line: 642,
          column: 22
        }
      },
      "70": {
        start: {
          line: 643,
          column: 22
        },
        end: {
          line: 643,
          column: 26
        }
      },
      "71": {
        start: {
          line: 644,
          column: 19
        },
        end: {
          line: 644,
          column: 23
        }
      },
      "72": {
        start: {
          line: 645,
          column: 21
        },
        end: {
          line: 645,
          column: 25
        }
      },
      "73": {
        start: {
          line: 646,
          column: 19
        },
        end: {
          line: 646,
          column: 21
        }
      },
      "74": {
        start: {
          line: 647,
          column: 23
        },
        end: {
          line: 647,
          column: 28
        }
      },
      "75": {
        start: {
          line: 648,
          column: 24
        },
        end: {
          line: 648,
          column: 29
        }
      },
      "76": {
        start: {
          line: 650,
          column: 2
        },
        end: {
          line: 680,
          column: 3
        }
      },
      "77": {
        start: {
          line: 651,
          column: 4
        },
        end: {
          line: 651,
          column: 33
        }
      },
      "78": {
        start: {
          line: 652,
          column: 4
        },
        end: {
          line: 658,
          column: 5
        }
      },
      "79": {
        start: {
          line: 653,
          column: 6
        },
        end: {
          line: 653,
          column: 29
        }
      },
      "80": {
        start: {
          line: 654,
          column: 6
        },
        end: {
          line: 654,
          column: 54
        }
      },
      "81": {
        start: {
          line: 655,
          column: 6
        },
        end: {
          line: 655,
          column: 89
        }
      },
      "82": {
        start: {
          line: 656,
          column: 6
        },
        end: {
          line: 656,
          column: 72
        }
      },
      "83": {
        start: {
          line: 657,
          column: 6
        },
        end: {
          line: 657,
          column: 86
        }
      },
      "84": {
        start: {
          line: 659,
          column: 4
        },
        end: {
          line: 679,
          column: 5
        }
      },
      "85": {
        start: {
          line: 660,
          column: 6
        },
        end: {
          line: 660,
          column: 29
        }
      },
      "86": {
        start: {
          line: 661,
          column: 6
        },
        end: {
          line: 663,
          column: 7
        }
      },
      "87": {
        start: {
          line: 662,
          column: 8
        },
        end: {
          line: 662,
          column: 39
        }
      },
      "88": {
        start: {
          line: 664,
          column: 6
        },
        end: {
          line: 666,
          column: 7
        }
      },
      "89": {
        start: {
          line: 665,
          column: 8
        },
        end: {
          line: 665,
          column: 33
        }
      },
      "90": {
        start: {
          line: 667,
          column: 6
        },
        end: {
          line: 669,
          column: 44
        }
      },
      "91": {
        start: {
          line: 670,
          column: 6
        },
        end: {
          line: 672,
          column: 80
        }
      },
      "92": {
        start: {
          line: 673,
          column: 6
        },
        end: {
          line: 675,
          column: 59
        }
      },
      "93": {
        start: {
          line: 676,
          column: 6
        },
        end: {
          line: 678,
          column: 72
        }
      },
      "94": {
        start: {
          line: 681,
          column: 2
        },
        end: {
          line: 690,
          column: 4
        }
      },
      "95": {
        start: {
          line: 694,
          column: 21
        },
        end: {
          line: 887,
          column: 1
        }
      },
      "96": {
        start: {
          line: 713,
          column: 8
        },
        end: {
          line: 713,
          column: 42
        }
      },
      "97": {
        start: {
          line: 714,
          column: 24
        },
        end: {
          line: 714,
          column: 96
        }
      },
      "98": {
        start: {
          line: 716,
          column: 24
        },
        end: {
          line: 716,
          column: 62
        }
      },
      "99": {
        start: {
          line: 717,
          column: 36
        },
        end: {
          line: 717,
          column: 64
        }
      },
      "100": {
        start: {
          line: 718,
          column: 26
        },
        end: {
          line: 718,
          column: 68
        }
      },
      "101": {
        start: {
          line: 719,
          column: 33
        },
        end: {
          line: 719,
          column: 58
        }
      },
      "102": {
        start: {
          line: 721,
          column: 47
        },
        end: {
          line: 725,
          column: 7
        }
      },
      "103": {
        start: {
          line: 726,
          column: 24
        },
        end: {
          line: 726,
          column: 80
        }
      },
      "104": {
        start: {
          line: 727,
          column: 28
        },
        end: {
          line: 729,
          column: 10
        }
      },
      "105": {
        start: {
          line: 728,
          column: 8
        },
        end: {
          line: 728,
          column: 37
        }
      },
      "106": {
        start: {
          line: 731,
          column: 29
        },
        end: {
          line: 753,
          column: 7
        }
      },
      "107": {
        start: {
          line: 732,
          column: 8
        },
        end: {
          line: 752,
          column: 28
        }
      },
      "108": {
        start: {
          line: 749,
          column: 51
        },
        end: {
          line: 749,
          column: 83
        }
      },
      "109": {
        start: {
          line: 755,
          column: 32
        },
        end: {
          line: 773,
          column: 7
        }
      },
      "110": {
        start: {
          line: 756,
          column: 8
        },
        end: {
          line: 772,
          column: 15
        }
      },
      "111": {
        start: {
          line: 775,
          column: 31
        },
        end: {
          line: 781,
          column: 7
        }
      },
      "112": {
        start: {
          line: 776,
          column: 8
        },
        end: {
          line: 780,
          column: 15
        }
      },
      "113": {
        start: {
          line: 783,
          column: 38
        },
        end: {
          line: 876,
          column: 7
        }
      },
      "114": {
        start: {
          line: 784,
          column: 32
        },
        end: {
          line: 784,
          column: 59
        }
      },
      "115": {
        start: {
          line: 785,
          column: 30
        },
        end: {
          line: 785,
          column: 43
        }
      },
      "116": {
        start: {
          line: 786,
          column: 26
        },
        end: {
          line: 786,
          column: 43
        }
      },
      "117": {
        start: {
          line: 787,
          column: 22
        },
        end: {
          line: 787,
          column: 86
        }
      },
      "118": {
        start: {
          line: 798,
          column: 12
        },
        end: {
          line: 798,
          column: 78
        }
      },
      "119": {
        start: {
          line: 801,
          column: 8
        },
        end: {
          line: 804,
          column: 9
        }
      },
      "120": {
        start: {
          line: 803,
          column: 10
        },
        end: {
          line: 803,
          column: 35
        }
      },
      "121": {
        start: {
          line: 806,
          column: 10
        },
        end: {
          line: 808,
          column: 12
        }
      },
      "122": {
        start: {
          line: 810,
          column: 8
        },
        end: {
          line: 845,
          column: 9
        }
      },
      "123": {
        start: {
          line: 811,
          column: 10
        },
        end: {
          line: 844,
          column: 12
        }
      },
      "124": {
        start: {
          line: 820,
          column: 18
        },
        end: {
          line: 824,
          column: 19
        }
      },
      "125": {
        start: {
          line: 846,
          column: 8
        },
        end: {
          line: 875,
          column: 10
        }
      },
      "126": {
        start: {
          line: 877,
          column: 6
        },
        end: {
          line: 884,
          column: 8
        }
      },
      "127": {
        start: {
          line: 889,
          column: 0
        },
        end: {
          line: 916,
          column: 2
        }
      },
      "128": {
        start: {
          line: 918,
          column: 0
        },
        end: {
          line: 935,
          column: 2
        }
      },
      "129": {
        start: {
          line: 940,
          column: 20
        },
        end: {
          line: 1053,
          column: 1
        }
      },
      "130": {
        start: {
          line: 957,
          column: 6
        },
        end: {
          line: 957,
          column: 11
        }
      },
      "131": {
        start: {
          line: 959,
          column: 37
        },
        end: {
          line: 959,
          column: 44
        }
      },
      "132": {
        start: {
          line: 962,
          column: 21
        },
        end: {
          line: 962,
          column: 55
        }
      },
      "133": {
        start: {
          line: 963,
          column: 4
        },
        end: {
          line: 963,
          column: 37
        }
      },
      "134": {
        start: {
          line: 964,
          column: 4
        },
        end: {
          line: 964,
          column: 52
        }
      },
      "135": {
        start: {
          line: 967,
          column: 24
        },
        end: {
          line: 973,
          column: 3
        }
      },
      "136": {
        start: {
          line: 975,
          column: 22
        },
        end: {
          line: 977,
          column: 3
        }
      },
      "137": {
        start: {
          line: 978,
          column: 18
        },
        end: {
          line: 978,
          column: 82
        }
      },
      "138": {
        start: {
          line: 979,
          column: 18
        },
        end: {
          line: 979,
          column: 73
        }
      },
      "139": {
        start: {
          line: 980,
          column: 36
        },
        end: {
          line: 980,
          column: 89
        }
      },
      "140": {
        start: {
          line: 981,
          column: 29
        },
        end: {
          line: 981,
          column: 91
        }
      },
      "141": {
        start: {
          line: 982,
          column: 23
        },
        end: {
          line: 987,
          column: 4
        }
      },
      "142": {
        start: {
          line: 990,
          column: 4
        },
        end: {
          line: 994,
          column: 25
        }
      },
      "143": {
        start: {
          line: 997,
          column: 2
        },
        end: {
          line: 1052,
          column: 4
        }
      },
      "144": {
        start: {
          line: 1055,
          column: 0
        },
        end: {
          line: 1082,
          column: 2
        }
      },
      "145": {
        start: {
          line: 1084,
          column: 0
        },
        end: {
          line: 1103,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 49,
            column: 15
          },
          end: {
            line: 49,
            column: 16
          }
        },
        loc: {
          start: {
            line: 49,
            column: 24
          },
          end: {
            line: 49,
            column: 76
          }
        },
        line: 49
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 66,
            column: 17
          },
          end: {
            line: 66,
            column: 18
          }
        },
        loc: {
          start: {
            line: 66,
            column: 32
          },
          end: {
            line: 66,
            column: 56
          }
        },
        line: 66
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 71,
            column: 26
          },
          end: {
            line: 71,
            column: 27
          }
        },
        loc: {
          start: {
            line: 71,
            column: 41
          },
          end: {
            line: 71,
            column: 74
          }
        },
        line: 71
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 75,
            column: 17
          },
          end: {
            line: 75,
            column: 18
          }
        },
        loc: {
          start: {
            line: 75,
            column: 32
          },
          end: {
            line: 75,
            column: 56
          }
        },
        line: 75
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 105,
            column: 15
          },
          end: {
            line: 105,
            column: 16
          }
        },
        loc: {
          start: {
            line: 106,
            column: 6
          },
          end: {
            line: 106,
            column: 95
          }
        },
        line: 106
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 132,
            column: 8
          },
          end: {
            line: 132,
            column: 9
          }
        },
        loc: {
          start: {
            line: 133,
            column: 8
          },
          end: {
            line: 136,
            column: 9
          }
        },
        line: 133
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 228,
            column: 15
          },
          end: {
            line: 228,
            column: 16
          }
        },
        loc: {
          start: {
            line: 228,
            column: 24
          },
          end: {
            line: 228,
            column: 42
          }
        },
        line: 228
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 230,
            column: 17
          },
          end: {
            line: 230,
            column: 18
          }
        },
        loc: {
          start: {
            line: 230,
            column: 26
          },
          end: {
            line: 230,
            column: 42
          }
        },
        line: 230
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 238,
            column: 15
          },
          end: {
            line: 238,
            column: 16
          }
        },
        loc: {
          start: {
            line: 238,
            column: 24
          },
          end: {
            line: 238,
            column: 40
          }
        },
        line: 238
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 253,
            column: 36
          },
          end: {
            line: 253,
            column: 37
          }
        },
        loc: {
          start: {
            line: 253,
            column: 66
          },
          end: {
            line: 253,
            column: 77
          }
        },
        line: 253
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 266,
            column: 36
          },
          end: {
            line: 266,
            column: 37
          }
        },
        loc: {
          start: {
            line: 266,
            column: 67
          },
          end: {
            line: 266,
            column: 78
          }
        },
        line: 266
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 290,
            column: 13
          },
          end: {
            line: 290,
            column: 14
          }
        },
        loc: {
          start: {
            line: 290,
            column: 22
          },
          end: {
            line: 290,
            column: 33
          }
        },
        line: 290
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 303,
            column: 15
          },
          end: {
            line: 303,
            column: 16
          }
        },
        loc: {
          start: {
            line: 303,
            column: 24
          },
          end: {
            line: 303,
            column: 35
          }
        },
        line: 303
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 373,
            column: 23
          },
          end: {
            line: 373,
            column: 24
          }
        },
        loc: {
          start: {
            line: 373,
            column: 116
          },
          end: {
            line: 406,
            column: 1
          }
        },
        line: 373
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 433,
            column: 19
          },
          end: {
            line: 433,
            column: 20
          }
        },
        loc: {
          start: {
            line: 434,
            column: 4
          },
          end: {
            line: 464,
            column: 19
          }
        },
        line: 434
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 482,
            column: 19
          },
          end: {
            line: 482,
            column: 20
          }
        },
        loc: {
          start: {
            line: 483,
            column: 4
          },
          end: {
            line: 500,
            column: 25
          }
        },
        line: 483
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 530,
            column: 6
          },
          end: {
            line: 530,
            column: 7
          }
        },
        loc: {
          start: {
            line: 540,
            column: 12
          },
          end: {
            line: 590,
            column: 7
          }
        },
        line: 540
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 541,
            column: 29
          },
          end: {
            line: 541,
            column: 30
          }
        },
        loc: {
          start: {
            line: 541,
            column: 35
          },
          end: {
            line: 547,
            column: 9
          }
        },
        line: 541
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 634,
            column: 32
          },
          end: {
            line: 634,
            column: 33
          }
        },
        loc: {
          start: {
            line: 634,
            column: 68
          },
          end: {
            line: 638,
            column: 1
          }
        },
        line: 634
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 640,
            column: 32
          },
          end: {
            line: 640,
            column: 33
          }
        },
        loc: {
          start: {
            line: 640,
            column: 79
          },
          end: {
            line: 691,
            column: 1
          }
        },
        line: 640
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 696,
            column: 4
          },
          end: {
            line: 696,
            column: 5
          }
        },
        loc: {
          start: {
            line: 711,
            column: 10
          },
          end: {
            line: 885,
            column: 5
          }
        },
        line: 711
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 727,
            column: 29
          },
          end: {
            line: 727,
            column: 30
          }
        },
        loc: {
          start: {
            line: 727,
            column: 35
          },
          end: {
            line: 729,
            column: 7
          }
        },
        line: 727
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 731,
            column: 29
          },
          end: {
            line: 731,
            column: 30
          }
        },
        loc: {
          start: {
            line: 732,
            column: 8
          },
          end: {
            line: 752,
            column: 28
          }
        },
        line: 732
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 749,
            column: 45
          },
          end: {
            line: 749,
            column: 46
          }
        },
        loc: {
          start: {
            line: 749,
            column: 51
          },
          end: {
            line: 749,
            column: 83
          }
        },
        line: 749
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 755,
            column: 32
          },
          end: {
            line: 755,
            column: 33
          }
        },
        loc: {
          start: {
            line: 756,
            column: 8
          },
          end: {
            line: 772,
            column: 15
          }
        },
        line: 756
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 775,
            column: 31
          },
          end: {
            line: 775,
            column: 32
          }
        },
        loc: {
          start: {
            line: 776,
            column: 8
          },
          end: {
            line: 780,
            column: 15
          }
        },
        line: 776
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 783,
            column: 38
          },
          end: {
            line: 783,
            column: 39
          }
        },
        loc: {
          start: {
            line: 783,
            column: 44
          },
          end: {
            line: 876,
            column: 7
          }
        },
        line: 783
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 819,
            column: 31
          },
          end: {
            line: 819,
            column: 32
          }
        },
        loc: {
          start: {
            line: 820,
            column: 18
          },
          end: {
            line: 824,
            column: 19
          }
        },
        line: 820
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 940,
            column: 20
          },
          end: {
            line: 940,
            column: 21
          }
        },
        loc: {
          start: {
            line: 940,
            column: 29
          },
          end: {
            line: 1053,
            column: 1
          }
        },
        line: 940
      },
      "29": {
        name: "decodeHtmlString",
        decl: {
          start: {
            line: 960,
            column: 11
          },
          end: {
            line: 960,
            column: 27
          }
        },
        loc: {
          start: {
            line: 960,
            column: 41
          },
          end: {
            line: 965,
            column: 3
          }
        },
        line: 960
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 66,
            column: 32
          },
          end: {
            line: 66,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 66,
            column: 32
          },
          end: {
            line: 66,
            column: 46
          }
        }, {
          start: {
            line: 66,
            column: 50
          },
          end: {
            line: 66,
            column: 56
          }
        }],
        line: 66
      },
      "1": {
        loc: {
          start: {
            line: 71,
            column: 41
          },
          end: {
            line: 71,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 71,
            column: 41
          },
          end: {
            line: 71,
            column: 61
          }
        }, {
          start: {
            line: 71,
            column: 65
          },
          end: {
            line: 71,
            column: 74
          }
        }],
        line: 71
      },
      "2": {
        loc: {
          start: {
            line: 75,
            column: 32
          },
          end: {
            line: 75,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 75,
            column: 32
          },
          end: {
            line: 75,
            column: 46
          }
        }, {
          start: {
            line: 75,
            column: 50
          },
          end: {
            line: 75,
            column: 56
          }
        }],
        line: 75
      },
      "3": {
        loc: {
          start: {
            line: 133,
            column: 8
          },
          end: {
            line: 136,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 133,
            column: 8
          },
          end: {
            line: 133,
            column: 14
          }
        }, {
          start: {
            line: 134,
            column: 8
          },
          end: {
            line: 136,
            column: 9
          }
        }],
        line: 133
      },
      "4": {
        loc: {
          start: {
            line: 253,
            column: 39
          },
          end: {
            line: 253,
            column: 59
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 253,
            column: 53
          },
          end: {
            line: 253,
            column: 59
          }
        }],
        line: 253
      },
      "5": {
        loc: {
          start: {
            line: 266,
            column: 39
          },
          end: {
            line: 266,
            column: 60
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 266,
            column: 53
          },
          end: {
            line: 266,
            column: 60
          }
        }],
        line: 266
      },
      "6": {
        loc: {
          start: {
            line: 390,
            column: 9
          },
          end: {
            line: 390,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 390,
            column: 9
          },
          end: {
            line: 390,
            column: 24
          }
        }, {
          start: {
            line: 390,
            column: 28
          },
          end: {
            line: 390,
            column: 66
          }
        }],
        line: 390
      },
      "7": {
        loc: {
          start: {
            line: 394,
            column: 9
          },
          end: {
            line: 401,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 394,
            column: 9
          },
          end: {
            line: 394,
            column: 17
          }
        }, {
          start: {
            line: 395,
            column: 10
          },
          end: {
            line: 400,
            column: 16
          }
        }],
        line: 394
      },
      "8": {
        loc: {
          start: {
            line: 439,
            column: 9
          },
          end: {
            line: 439,
            column: 92
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 439,
            column: 10
          },
          end: {
            line: 439,
            column: 27
          }
        }, {
          start: {
            line: 439,
            column: 31
          },
          end: {
            line: 439,
            column: 55
          }
        }, {
          start: {
            line: 439,
            column: 60
          },
          end: {
            line: 439,
            column: 92
          }
        }],
        line: 439
      },
      "9": {
        loc: {
          start: {
            line: 446,
            column: 9
          },
          end: {
            line: 451,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 446,
            column: 10
          },
          end: {
            line: 446,
            column: 27
          }
        }, {
          start: {
            line: 446,
            column: 31
          },
          end: {
            line: 446,
            column: 47
          }
        }, {
          start: {
            line: 447,
            column: 10
          },
          end: {
            line: 450,
            column: 40
          }
        }],
        line: 446
      },
      "10": {
        loc: {
          start: {
            line: 448,
            column: 13
          },
          end: {
            line: 448,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 448,
            column: 13
          },
          end: {
            line: 448,
            column: 36
          }
        }, {
          start: {
            line: 448,
            column: 40
          },
          end: {
            line: 448,
            column: 81
          }
        }],
        line: 448
      },
      "11": {
        loc: {
          start: {
            line: 449,
            column: 13
          },
          end: {
            line: 449,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 449,
            column: 13
          },
          end: {
            line: 449,
            column: 30
          }
        }, {
          start: {
            line: 449,
            column: 34
          },
          end: {
            line: 449,
            column: 50
          }
        }],
        line: 449
      },
      "12": {
        loc: {
          start: {
            line: 452,
            column: 9
          },
          end: {
            line: 456,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 452,
            column: 9
          },
          end: {
            line: 452,
            column: 31
          }
        }, {
          start: {
            line: 453,
            column: 10
          },
          end: {
            line: 455,
            column: 35
          }
        }],
        line: 452
      },
      "13": {
        loc: {
          start: {
            line: 462,
            column: 7
          },
          end: {
            line: 462,
            column: 93
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 462,
            column: 7
          },
          end: {
            line: 462,
            column: 29
          }
        }, {
          start: {
            line: 462,
            column: 33
          },
          end: {
            line: 462,
            column: 93
          }
        }],
        line: 462
      },
      "14": {
        loc: {
          start: {
            line: 485,
            column: 9
          },
          end: {
            line: 485,
            column: 57
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 485,
            column: 36
          },
          end: {
            line: 485,
            column: 42
          }
        }, {
          start: {
            line: 485,
            column: 45
          },
          end: {
            line: 485,
            column: 57
          }
        }],
        line: 485
      },
      "15": {
        loc: {
          start: {
            line: 487,
            column: 19
          },
          end: {
            line: 487,
            column: 96
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 487,
            column: 44
          },
          end: {
            line: 487,
            column: 84
          }
        }, {
          start: {
            line: 487,
            column: 87
          },
          end: {
            line: 487,
            column: 96
          }
        }],
        line: 487
      },
      "16": {
        loc: {
          start: {
            line: 488,
            column: 7
          },
          end: {
            line: 499,
            column: 7
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 489,
            column: 8
          },
          end: {
            line: 489,
            column: 107
          }
        }, {
          start: {
            line: 491,
            column: 8
          },
          end: {
            line: 498,
            column: 10
          }
        }],
        line: 488
      },
      "17": {
        loc: {
          start: {
            line: 542,
            column: 10
          },
          end: {
            line: 544,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 542,
            column: 10
          },
          end: {
            line: 544,
            column: 11
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 542
      },
      "18": {
        loc: {
          start: {
            line: 546,
            column: 17
          },
          end: {
            line: 546,
            column: 57
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 546,
            column: 35
          },
          end: {
            line: 546,
            column: 43
          }
        }, {
          start: {
            line: 546,
            column: 46
          },
          end: {
            line: 546,
            column: 57
          }
        }],
        line: 546
      },
      "19": {
        loc: {
          start: {
            line: 549,
            column: 8
          },
          end: {
            line: 566,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 549,
            column: 8
          },
          end: {
            line: 566,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 549
      },
      "20": {
        loc: {
          start: {
            line: 552,
            column: 28
          },
          end: {
            line: 552,
            column: 70
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 552,
            column: 55
          },
          end: {
            line: 552,
            column: 61
          }
        }, {
          start: {
            line: 552,
            column: 64
          },
          end: {
            line: 552,
            column: 70
          }
        }],
        line: 552
      },
      "21": {
        loc: {
          start: {
            line: 553,
            column: 26
          },
          end: {
            line: 553,
            column: 67
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 553,
            column: 53
          },
          end: {
            line: 553,
            column: 58
          }
        }, {
          start: {
            line: 553,
            column: 61
          },
          end: {
            line: 553,
            column: 67
          }
        }],
        line: 553
      },
      "22": {
        loc: {
          start: {
            line: 582,
            column: 8
          },
          end: {
            line: 584,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 582,
            column: 8
          },
          end: {
            line: 584,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 582
      },
      "23": {
        loc: {
          start: {
            line: 582,
            column: 12
          },
          end: {
            line: 582,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 582,
            column: 12
          },
          end: {
            line: 582,
            column: 29
          }
        }, {
          start: {
            line: 582,
            column: 33
          },
          end: {
            line: 582,
            column: 51
          }
        }],
        line: 582
      },
      "24": {
        loc: {
          start: {
            line: 635,
            column: 2
          },
          end: {
            line: 635,
            column: 41
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 635,
            column: 2
          },
          end: {
            line: 635,
            column: 41
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 635
      },
      "25": {
        loc: {
          start: {
            line: 636,
            column: 2
          },
          end: {
            line: 636,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 636,
            column: 2
          },
          end: {
            line: 636,
            column: 35
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 636
      },
      "26": {
        loc: {
          start: {
            line: 650,
            column: 2
          },
          end: {
            line: 680,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 650,
            column: 2
          },
          end: {
            line: 680,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 650
      },
      "27": {
        loc: {
          start: {
            line: 650,
            column: 6
          },
          end: {
            line: 650,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 650,
            column: 6
          },
          end: {
            line: 650,
            column: 40
          }
        }, {
          start: {
            line: 650,
            column: 44
          },
          end: {
            line: 650,
            column: 73
          }
        }],
        line: 650
      },
      "28": {
        loc: {
          start: {
            line: 652,
            column: 4
          },
          end: {
            line: 658,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 652,
            column: 4
          },
          end: {
            line: 658,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 652
      },
      "29": {
        loc: {
          start: {
            line: 659,
            column: 4
          },
          end: {
            line: 679,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 659,
            column: 4
          },
          end: {
            line: 679,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 659
      },
      "30": {
        loc: {
          start: {
            line: 661,
            column: 6
          },
          end: {
            line: 663,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 661,
            column: 6
          },
          end: {
            line: 663,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 661
      },
      "31": {
        loc: {
          start: {
            line: 664,
            column: 6
          },
          end: {
            line: 666,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 664,
            column: 6
          },
          end: {
            line: 666,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 664
      },
      "32": {
        loc: {
          start: {
            line: 667,
            column: 21
          },
          end: {
            line: 669,
            column: 43
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 668,
            column: 10
          },
          end: {
            line: 668,
            column: 46
          }
        }, {
          start: {
            line: 669,
            column: 10
          },
          end: {
            line: 669,
            column: 43
          }
        }],
        line: 667
      },
      "33": {
        loc: {
          start: {
            line: 670,
            column: 19
          },
          end: {
            line: 672,
            column: 79
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 671,
            column: 10
          },
          end: {
            line: 671,
            column: 83
          }
        }, {
          start: {
            line: 672,
            column: 10
          },
          end: {
            line: 672,
            column: 79
          }
        }],
        line: 670
      },
      "34": {
        loc: {
          start: {
            line: 673,
            column: 23
          },
          end: {
            line: 675,
            column: 58
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 674,
            column: 10
          },
          end: {
            line: 674,
            column: 62
          }
        }, {
          start: {
            line: 675,
            column: 10
          },
          end: {
            line: 675,
            column: 58
          }
        }],
        line: 673
      },
      "35": {
        loc: {
          start: {
            line: 676,
            column: 24
          },
          end: {
            line: 678,
            column: 71
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 677,
            column: 10
          },
          end: {
            line: 677,
            column: 75
          }
        }, {
          start: {
            line: 678,
            column: 10
          },
          end: {
            line: 678,
            column: 71
          }
        }],
        line: 676
      },
      "36": {
        loc: {
          start: {
            line: 713,
            column: 8
          },
          end: {
            line: 713,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 713,
            column: 8
          },
          end: {
            line: 713,
            column: 19
          }
        }, {
          start: {
            line: 713,
            column: 23
          },
          end: {
            line: 713,
            column: 31
          }
        }, {
          start: {
            line: 713,
            column: 35
          },
          end: {
            line: 713,
            column: 42
          }
        }],
        line: 713
      },
      "37": {
        loc: {
          start: {
            line: 714,
            column: 24
          },
          end: {
            line: 714,
            column: 96
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 714,
            column: 25
          },
          end: {
            line: 714,
            column: 36
          }
        }, {
          start: {
            line: 714,
            column: 40
          },
          end: {
            line: 714,
            column: 61
          }
        }, {
          start: {
            line: 714,
            column: 67
          },
          end: {
            line: 714,
            column: 74
          }
        }, {
          start: {
            line: 714,
            column: 78
          },
          end: {
            line: 714,
            column: 95
          }
        }],
        line: 714
      },
      "38": {
        loc: {
          start: {
            line: 716,
            column: 24
          },
          end: {
            line: 716,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 716,
            column: 24
          },
          end: {
            line: 716,
            column: 47
          }
        }, {
          start: {
            line: 716,
            column: 51
          },
          end: {
            line: 716,
            column: 62
          }
        }],
        line: 716
      },
      "39": {
        loc: {
          start: {
            line: 717,
            column: 36
          },
          end: {
            line: 717,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 717,
            column: 36
          },
          end: {
            line: 717,
            column: 46
          }
        }, {
          start: {
            line: 717,
            column: 50
          },
          end: {
            line: 717,
            column: 64
          }
        }],
        line: 717
      },
      "40": {
        loc: {
          start: {
            line: 718,
            column: 26
          },
          end: {
            line: 718,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 718,
            column: 26
          },
          end: {
            line: 718,
            column: 36
          }
        }, {
          start: {
            line: 718,
            column: 40
          },
          end: {
            line: 718,
            column: 68
          }
        }],
        line: 718
      },
      "41": {
        loc: {
          start: {
            line: 719,
            column: 33
          },
          end: {
            line: 719,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 719,
            column: 33
          },
          end: {
            line: 719,
            column: 43
          }
        }, {
          start: {
            line: 719,
            column: 47
          },
          end: {
            line: 719,
            column: 58
          }
        }],
        line: 719
      },
      "42": {
        loc: {
          start: {
            line: 736,
            column: 11
          },
          end: {
            line: 745,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 736,
            column: 11
          },
          end: {
            line: 736,
            column: 29
          }
        }, {
          start: {
            line: 737,
            column: 12
          },
          end: {
            line: 737,
            column: 34
          }
        }, {
          start: {
            line: 738,
            column: 14
          },
          end: {
            line: 744,
            column: 16
          }
        }],
        line: 736
      },
      "43": {
        loc: {
          start: {
            line: 746,
            column: 11
          },
          end: {
            line: 751,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 746,
            column: 11
          },
          end: {
            line: 746,
            column: 43
          }
        }, {
          start: {
            line: 747,
            column: 12
          },
          end: {
            line: 750,
            column: 14
          }
        }],
        line: 746
      },
      "44": {
        loc: {
          start: {
            line: 760,
            column: 11
          },
          end: {
            line: 771,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 760,
            column: 11
          },
          end: {
            line: 760,
            column: 25
          }
        }, {
          start: {
            line: 761,
            column: 12
          },
          end: {
            line: 770,
            column: 29
          }
        }],
        line: 760
      },
      "45": {
        loc: {
          start: {
            line: 784,
            column: 32
          },
          end: {
            line: 784,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 784,
            column: 32
          },
          end: {
            line: 784,
            column: 41
          }
        }, {
          start: {
            line: 784,
            column: 45
          },
          end: {
            line: 784,
            column: 59
          }
        }],
        line: 784
      },
      "46": {
        loc: {
          start: {
            line: 801,
            column: 8
          },
          end: {
            line: 804,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 801,
            column: 8
          },
          end: {
            line: 804,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 801
      },
      "47": {
        loc: {
          start: {
            line: 807,
            column: 16
          },
          end: {
            line: 807,
            column: 84
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 807,
            column: 26
          },
          end: {
            line: 807,
            column: 54
          }
        }, {
          start: {
            line: 807,
            column: 57
          },
          end: {
            line: 807,
            column: 84
          }
        }],
        line: 807
      },
      "48": {
        loc: {
          start: {
            line: 810,
            column: 8
          },
          end: {
            line: 845,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 810,
            column: 8
          },
          end: {
            line: 845,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 810
      },
      "49": {
        loc: {
          start: {
            line: 829,
            column: 18
          },
          end: {
            line: 831,
            column: 71
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 830,
            column: 22
          },
          end: {
            line: 830,
            column: 70
          }
        }, {
          start: {
            line: 831,
            column: 22
          },
          end: {
            line: 831,
            column: 71
          }
        }],
        line: 829
      },
      "50": {
        loc: {
          start: {
            line: 834,
            column: 18
          },
          end: {
            line: 839,
            column: 26
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 835,
            column: 20
          },
          end: {
            line: 838,
            column: 22
          }
        }, {
          start: {
            line: 839,
            column: 22
          },
          end: {
            line: 839,
            column: 26
          }
        }],
        line: 834
      },
      "51": {
        loc: {
          start: {
            line: 848,
            column: 13
          },
          end: {
            line: 863,
            column: 15
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 848,
            column: 13
          },
          end: {
            line: 848,
            column: 28
          }
        }, {
          start: {
            line: 849,
            column: 14
          },
          end: {
            line: 849,
            column: 23
          }
        }, {
          start: {
            line: 850,
            column: 16
          },
          end: {
            line: 862,
            column: 22
          }
        }],
        line: 848
      },
      "52": {
        loc: {
          start: {
            line: 879,
            column: 11
          },
          end: {
            line: 879,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 879,
            column: 11
          },
          end: {
            line: 879,
            column: 22
          }
        }, {
          start: {
            line: 879,
            column: 26
          },
          end: {
            line: 879,
            column: 46
          }
        }],
        line: 879
      },
      "53": {
        loc: {
          start: {
            line: 880,
            column: 11
          },
          end: {
            line: 880,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 880,
            column: 11
          },
          end: {
            line: 880,
            column: 23
          }
        }, {
          start: {
            line: 880,
            column: 27
          },
          end: {
            line: 880,
            column: 48
          }
        }, {
          start: {
            line: 880,
            column: 52
          },
          end: {
            line: 880,
            column: 73
          }
        }],
        line: 880
      },
      "54": {
        loc: {
          start: {
            line: 881,
            column: 11
          },
          end: {
            line: 881,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 881,
            column: 11
          },
          end: {
            line: 881,
            column: 20
          }
        }, {
          start: {
            line: 881,
            column: 24
          },
          end: {
            line: 881,
            column: 42
          }
        }],
        line: 881
      },
      "55": {
        loc: {
          start: {
            line: 882,
            column: 11
          },
          end: {
            line: 882,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 882,
            column: 11
          },
          end: {
            line: 882,
            column: 29
          }
        }, {
          start: {
            line: 882,
            column: 33
          },
          end: {
            line: 882,
            column: 60
          }
        }],
        line: 882
      },
      "56": {
        loc: {
          start: {
            line: 964,
            column: 11
          },
          end: {
            line: 964,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 964,
            column: 25
          },
          end: {
            line: 964,
            column: 39
          }
        }, {
          start: {
            line: 964,
            column: 42
          },
          end: {
            line: 964,
            column: 51
          }
        }],
        line: 964
      },
      "57": {
        loc: {
          start: {
            line: 978,
            column: 26
          },
          end: {
            line: 978,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 978,
            column: 26
          },
          end: {
            line: 978,
            column: 66
          }
        }, {
          start: {
            line: 978,
            column: 70
          },
          end: {
            line: 978,
            column: 81
          }
        }],
        line: 978
      },
      "58": {
        loc: {
          start: {
            line: 981,
            column: 29
          },
          end: {
            line: 981,
            column: 91
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 981,
            column: 29
          },
          end: {
            line: 981,
            column: 56
          }
        }, {
          start: {
            line: 981,
            column: 60
          },
          end: {
            line: 981,
            column: 91
          }
        }],
        line: 981
      },
      "59": {
        loc: {
          start: {
            line: 1017,
            column: 28
          },
          end: {
            line: 1018,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 1017,
            column: 28
          },
          end: {
            line: 1017,
            column: 50
          }
        }, {
          start: {
            line: 1017,
            column: 54
          },
          end: {
            line: 1017,
            column: 69
          }
        }, {
          start: {
            line: 1018,
            column: 10
          },
          end: {
            line: 1018,
            column: 21
          }
        }, {
          start: {
            line: 1018,
            column: 25
          },
          end: {
            line: 1018,
            column: 43
          }
        }],
        line: 1017
      },
      "60": {
        loc: {
          start: {
            line: 1030,
            column: 7
          },
          end: {
            line: 1045,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 1030,
            column: 7
          },
          end: {
            line: 1030,
            column: 20
          }
        }, {
          start: {
            line: 1031,
            column: 8
          },
          end: {
            line: 1044,
            column: 27
          }
        }],
        line: 1030
      },
      "61": {
        loc: {
          start: {
            line: 1033,
            column: 13
          },
          end: {
            line: 1037,
            column: 13
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 1034,
            column: 14
          },
          end: {
            line: 1034,
            column: 80
          }
        }, {
          start: {
            line: 1036,
            column: 14
          },
          end: {
            line: 1036,
            column: 92
          }
        }],
        line: 1033
      },
      "62": {
        loc: {
          start: {
            line: 1038,
            column: 13
          },
          end: {
            line: 1042,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 1038,
            column: 13
          },
          end: {
            line: 1038,
            column: 35
          }
        }, {
          start: {
            line: 1039,
            column: 14
          },
          end: {
            line: 1041,
            column: 23
          }
        }],
        line: 1038
      },
      "63": {
        loc: {
          start: {
            line: 1046,
            column: 7
          },
          end: {
            line: 1047,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 1046,
            column: 7
          },
          end: {
            line: 1046,
            column: 31
          }
        }, {
          start: {
            line: 1046,
            column: 35
          },
          end: {
            line: 1046,
            column: 50
          }
        }, {
          start: {
            line: 1047,
            column: 8
          },
          end: {
            line: 1047,
            column: 19
          }
        }, {
          start: {
            line: 1047,
            column: 23
          },
          end: {
            line: 1047,
            column: 41
          }
        }],
        line: 1046
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0],
      "5": [0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0, 0],
      "9": [0, 0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0, 0],
      "37": [0, 0, 0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0, 0],
      "52": [0, 0],
      "53": [0, 0, 0],
      "54": [0, 0],
      "55": [0, 0],
      "56": [0, 0],
      "57": [0, 0],
      "58": [0, 0],
      "59": [0, 0, 0, 0],
      "60": [0, 0],
      "61": [0, 0],
      "62": [0, 0],
      "63": [0, 0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "73b9120b54d5a5ade454c347c207d2e6361458bd"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2qgp94n5nb = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2qgp94n5nb();
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var ACCESSIBILITY_TITLE_PREFIX = (cov_2qgp94n5nb().s[0]++, 'accessibility_title_');
var Wrapper = (cov_2qgp94n5nb().s[1]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: function className(props) {
    cov_2qgp94n5nb().f[0]++;
    cov_2qgp94n5nb().s[2]++;
    return "stx-ProductLine stx-ProductLine-".concat(props.productId);
  }
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      flex-wrap: wrap;\n      padding: ", " ", ";\n      position: relative;\n    "])), _stylingConstants.default.spacing.small, _stylingConstants.default.spacing.medium)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      flex-wrap: wrap;\n      position: relative;\n      padding: ", ";\n      border-radius: var(--generalBorderRadius, 12px);\n      ", ";\n      background-color: ", ";\n      gap: 24px;\n      .stx-MainContent {\n        .stx-product-content {\n          gap: ", ";\n          div:not(.stx-Advantage):not(.stx-AdvantageIndicator) {\n            padding: 0;\n            margin: 0;\n            .stx-ProductCardTitle {\n              margin: 0;\n            }\n          }\n          .stx-ProductDate .g-Icon {\n            width: 16px;\n            height: 18px;\n            color: var(--subtleTextColor, #7f8c8d);\n          }\n          div .g-Icon-map {\n            margin-right: 10px;\n            width: 14px;\n            height: 18px;\n          }\n\n          p.semantic-no-styling {\n            color: var(--subtleTextColor);\n          }\n        }\n      }\n    "])), function (_ref) {
  var theme = _ref.theme;
  cov_2qgp94n5nb().f[1]++;
  cov_2qgp94n5nb().s[3]++;
  return (cov_2qgp94n5nb().b[0][0]++, theme.spacingX) || (cov_2qgp94n5nb().b[0][1]++, '12px');
}, (0, _utils.boxShadowOf)('Card', {
  defaultValue: (0, _get.default)(_themeMapper.evolutionTheme, 'productLine.boxShadow')
}), function (_ref2) {
  var theme = _ref2.theme;
  cov_2qgp94n5nb().f[2]++;
  cov_2qgp94n5nb().s[4]++;
  return (cov_2qgp94n5nb().b[1][0]++, theme.contentBgColor) || (cov_2qgp94n5nb().b[1][1]++, '#ffffff');
}, function (_ref3) {
  var theme = _ref3.theme;
  cov_2qgp94n5nb().f[3]++;
  cov_2qgp94n5nb().s[5]++;
  return (cov_2qgp94n5nb().b[2][0]++, theme.spacingY) || (cov_2qgp94n5nb().b[2][1]++, '16px');
}))));
var RightContentWrapper = (cov_2qgp94n5nb().s[6]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Flex).attrs({
  className: function className(props) {
    cov_2qgp94n5nb().f[4]++;
    cov_2qgp94n5nb().s[7]++;
    return "stx-RightContent stx-ActionButtonContainer stx-ActionButtonContainer-".concat(props.productId);
  }
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n      @media screen and (max-width: 52em) {\n        width: 100%;\n        max-width: 100%;\n      }\n      button,\n      a {\n        width: 100%;\n        max-width: 100%;\n      }\n    "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n      ", ";\n\n      button,\n      a {\n        width: 100%;\n        max-width: 100%;\n      }\n\n      ", ";\n\n      > .stx-ProductLineActionButton {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n\n        > .stx-RightContentButtonWrapper {\n          width: 100%;\n        }\n\n        > .stx-ProductActions {\n          > .stx-ProductActions-BoxWrapper {\n            width: 100%;\n          }\n\n          :empty {\n            display: none;\n          }\n        }\n      }\n\n      > .stx-ComingSoonContent {\n        align-items: center;\n      }\n    "])), _utils.gDesktopFirstMediaQueries.lg(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n          width: 100%;\n          max-width: 100%;\n      "]))), function (_ref4) {
  var column = _ref4.column;
  cov_2qgp94n5nb().f[5]++;
  cov_2qgp94n5nb().s[8]++;
  return (cov_2qgp94n5nb().b[3][0]++, column) && (cov_2qgp94n5nb().b[3][1]++, (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n          flex-direction: column;\n        "]))));
}))));
var RestrictedAdvBox = (cov_2qgp94n5nb().s[9]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Box).attrs({
  className: 'stx-RestrictedAdvBox'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n    font-size: ", ";\n  "])), _stylingConstants.default.font.sizeS)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n    font-size: ", ";\n  "])), _themeMapper.evolutionTheme.typography.caption2.fontSize))));
var MatchDate = (cov_2qgp94n5nb().s[10]++, (0, _styledComponents.default)(_ProductDate.default).attrs({
  className: 'stx-MatchDate'
})(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n  font-size: ", ";\n"])), _stylingConstants.default.font.sizeS));
var ImageWrapper = (cov_2qgp94n5nb().s[11]++, _styledComponents.default.div.attrs({
  className: 'stx-backdropContainer'
})(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n  height: 100%;\n  width: 100%;\n  position: relative;\n"]))));
var MatchIndicator = (cov_2qgp94n5nb().s[12]++, (0, _styledComponents.default)(_ProductIndicator.default).attrs({
  className: 'stx-matchIndicator'
})(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  top: 0;\n  right: 0;\n"]))));
var CenterText = (cov_2qgp94n5nb().s[13]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Flex).attrs({
  className: 'stx-RightContentText'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2.default)(["\n      justify-content: center;\n      text-transform: uppercase;\n    "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2.default)(["\n      justify-content: center;\n      color: var(--textColor, #212121);\n      font-size: ", ";\n      line-height: ", ";\n      font-weight: ", ";\n    "])), (0, _get.default)(_themeMapper.evolutionTheme, 'typography.caption1.fontSize'), (0, _get.default)(_themeMapper.evolutionTheme, 'typography.caption1.lineHeight'), (0, _get.default)(_themeMapper.evolutionTheme, 'fontWeight.medium')))));
var FlexCenteredOnPhone = (cov_2qgp94n5nb().s[14]++, (0, _styledComponents.default)(_gridStyled.Flex)(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2.default)(["\n  @media screen and (max-width: 40em) {\n    margin-left: auto;\n    margin-right: auto;\n    text-align: center;\n  }\n"]))));
var FixedWrapper = (cov_2qgp94n5nb().s[15]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: "stx-FixedWrapper"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject15 || (_templateObject15 = (0, _taggedTemplateLiteral2.default)(["\n      width: ", ";\n      @media screen and (max-width: 40em) {\n        width: ", ";\n        margin-left: auto;\n        margin-right: auto;\n        min-width: 100px;\n        max-width: 250px;\n      }\n    "])), function (props) {
  cov_2qgp94n5nb().f[6]++;
  cov_2qgp94n5nb().s[16]++;
  return props.desktopWidth;
}, function (props) {
  cov_2qgp94n5nb().f[7]++;
  cov_2qgp94n5nb().s[17]++;
  return props.phoneWidth;
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject16 || (_templateObject16 = (0, _taggedTemplateLiteral2.default)(["\n      width: ", ";\n      align-self: flex-start;\n      ", ";\n    "])), function (props) {
  cov_2qgp94n5nb().f[8]++;
  cov_2qgp94n5nb().s[18]++;
  return props.phoneWidth;
}, _utils.gMediaQueries.lg(_templateObject17 || (_templateObject17 = (0, _taggedTemplateLiteral2.default)(["\n        width: 148px;\n        max-height: 216px;\n      "])))))));
var MainContentWrapper = (cov_2qgp94n5nb().s[19]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Flex).attrs({
  className: 'stx-MainContent'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject18 || (_templateObject18 = (0, _taggedTemplateLiteral2.default)(["\n    flex: 1;\n    margin-left: 1rem;\n\n    @media screen and (max-width: ", ") {\n      width: 100%;\n      flex: none;\n      margin-left: 0;\n      padding: 0;\n      padding: 0.5rem 0 0 0;\n    }\n  "])), function (_ref5) {
  var _ref5$mobileWidth = _ref5.mobileWidth,
    mobileWidth = _ref5$mobileWidth === void 0 ? (cov_2qgp94n5nb().b[4][0]++, '40em') : _ref5$mobileWidth;
  cov_2qgp94n5nb().f[9]++;
  cov_2qgp94n5nb().s[20]++;
  return mobileWidth;
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject19 || (_templateObject19 = (0, _taggedTemplateLiteral2.default)(["\n    flex: 1;\n    padding: 0;\n    align-self: self-start;\n\n    @media screen and (max-width: ", ") {\n      width: 100%;\n      flex: none;\n    }\n  "])), function (_ref6) {
  var _ref6$mobileWidth = _ref6.mobileWidth,
    mobileWidth = _ref6$mobileWidth === void 0 ? (cov_2qgp94n5nb().b[5][0]++, '391px') : _ref6$mobileWidth;
  cov_2qgp94n5nb().f[10]++;
  cov_2qgp94n5nb().s[21]++;
  return mobileWidth;
}))));
var MatchWrapper = (cov_2qgp94n5nb().s[22]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Flex), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject20 || (_templateObject20 = (0, _taggedTemplateLiteral2.default)(["\n    position: static;\n    top: 1rem;\n    @media screen and (max-width: 40em) {\n      position: relative;\n      top: 0;\n    }\n  "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject21 || (_templateObject21 = (0, _taggedTemplateLiteral2.default)(["\n    flex-wrap: wrap-reverse;\n  "]))))));
var CustomWidth = (cov_2qgp94n5nb().s[23]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Flex), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject22 || (_templateObject22 = (0, _taggedTemplateLiteral2.default)(["\n    flex-direction: column;\n    width: ", ";\n    @media screen and (max-width: 40em) {\n      width: 100%;\n      text-align: center;\n    }\n  "])), function (props) {
  cov_2qgp94n5nb().f[11]++;
  cov_2qgp94n5nb().s[24]++;
  return props.width;
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject23 || (_templateObject23 = (0, _taggedTemplateLiteral2.default)(["\n    width: 100%;\n    flex-direction: column;\n    text-align: left;\n    justify-content: center;\n\n    ", ";\n\n    .stx-matchIndicator {\n      margin-bottom: ", "px;\n    }\n  "])), _utils.gMediaQueries.lg(_templateObject24 || (_templateObject24 = (0, _taggedTemplateLiteral2.default)(["\n      width: ", ";\n      text-align: initial;\n    "])), function (props) {
  cov_2qgp94n5nb().f[12]++;
  cov_2qgp94n5nb().s[25]++;
  return props.width;
}), (_themeMapper.evolutionTheme, 'spacings.lg', 16)))));
var RightContentButton = (cov_2qgp94n5nb().s[26]++, (0, _styledComponents.default)(_button.default)(_templateObject25 || (_templateObject25 = (0, _taggedTemplateLiteral2.default)(["\n  margin: 0;\n  display: flex;\n  margin-top: 0.5rem;\n  height: 100%;\n  line-height: 17px;\n  padding: 0.7rem 1rem;\n  span {\n    margin: auto;\n  }\n"]))));
var RelativeProductIndicator = (cov_2qgp94n5nb().s[27]++, (0, _styledComponents.default)(_ProductIndicator.default)(_templateObject26 || (_templateObject26 = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  top: 0;\n  right: 0;\n"]))));
var AccessibilityHeading = (cov_2qgp94n5nb().s[28]++, _styledComponents.default.h3.attrs({
  className: 'accessibility-visually-hidden'
})(_templateObject27 || (_templateObject27 = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  left: 0px;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n"]))));
var AccessibilityTitleContent = (cov_2qgp94n5nb().s[29]++, _styledComponents.default.span.attrs({
  className: 'accessibility-visually-hidden'
})(_templateObject28 || (_templateObject28 = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  left: 0px;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n"]))));
var BoxSoldOutContent = (cov_2qgp94n5nb().s[30]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Box).attrs({
  className: "stx-souldOutContent"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject29 || (_templateObject29 = (0, _taggedTemplateLiteral2.default)(["\n      display: flex;\n      flex-direction: column;\n    "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject30 || (_templateObject30 = (0, _taggedTemplateLiteral2.default)(["\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n\n      > .stx-ProductActions {\n        > .stx-ProductActions-BoxWrapper {\n          width: 100%;\n        }\n      }\n    "]))))));
cov_2qgp94n5nb().s[31]++;
var ProductContent = function ProductContent(_ref7) {
  var product = _ref7.product,
    timeslot = _ref7.timeslot,
    performance = _ref7.performance,
    replaceProductNameByPerformance = _ref7.replaceProductNameByPerformance,
    productDescription = _ref7.productDescription;
  cov_2qgp94n5nb().f[13]++;
  // Display as normal
  var productSubtitle = (cov_2qgp94n5nb().s[32]++, _ProductHelper.default.getProductSubtitle({
    product: product,
    performance: performance
  }));
  var location = (cov_2qgp94n5nb().s[33]++, product.location);
  cov_2qgp94n5nb().s[34]++;
  return /*#__PURE__*/_react.default.createElement(FlexCenteredOnPhone, {
    direction: 'column',
    className: "stx-product-content",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 379,
      columnNumber: 5
    }
  }, /*#__PURE__*/_react.default.createElement(_gridStyled.Box, {
    py: [0, 1, 1],
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 380,
      columnNumber: 7
    }
  }, /*#__PURE__*/_react.default.createElement(RelativeProductIndicator, {
    product: product,
    performance: performance,
    timeslot: timeslot,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 381,
      columnNumber: 9
    }
  }), /*#__PURE__*/_react.default.createElement(_ProductTitle.NonHeadingTitle, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 382,
      columnNumber: 9
    }
  }, _ProductHelper.default.getProductTitle({
    product: product,
    performance: performance,
    intl: null,
    usePerformanceName: replaceProductNameByPerformance
  })), (cov_2qgp94n5nb().b[6][0]++, productSubtitle) && (cov_2qgp94n5nb().b[6][1]++, /*#__PURE__*/_react.default.createElement(_ProductTitle.SubTitle, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 390,
      columnNumber: 29
    }
  }, productSubtitle))), /*#__PURE__*/_react.default.createElement(_gridStyled.Flex, {
    py: [0, 1, 1],
    direction: 'column',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 392,
      columnNumber: 7
    }
  }, /*#__PURE__*/_react.default.createElement(_ProductDate.default, {
    product: product,
    performance: performance,
    timeslot: timeslot,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 393,
      columnNumber: 9
    }
  }), (cov_2qgp94n5nb().b[7][0]++, location) && (cov_2qgp94n5nb().b[7][1]++, /*#__PURE__*/_react.default.createElement("div", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 395,
      columnNumber: 11
    }
  }, /*#__PURE__*/_react.default.createElement(_ProductDescriptionIcon.default, {
    iconName: "map",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 396,
      columnNumber: 13
    }
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "semantic-no-styling",
    style: {
      display: 'inline-block'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 397,
      columnNumber: 13
    }
  }, location)))), productDescription);
};
cov_2qgp94n5nb().s[35]++;
ProductContent.propTypes = {
  /* The product object to display */
  product: _product.ProductType.isRequired,
  /* A specific performance to display, if provided take the performance data in priority */
  performance: _product.PerformanceType,
  /* a specific timeslot to display, if provided take the timeslotData in priority */
  timeslot: _product.TimeslotType,
  replaceProductNameByPerformance: _propTypes.default.bool
};
cov_2qgp94n5nb().s[36]++;
ProductContent.defaultProps = {
  performance: undefined,
  timeslot: undefined,
  replaceProductNameByPerformance: false
};
var MatchContentLocationWrapper = (cov_2qgp94n5nb().s[37]++, (0, _utils.withThemedStyles)(_styledComponents.default.div, (0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject31 || (_templateObject31 = (0, _taggedTemplateLiteral2.default)(["\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n  "])), _themeMapper.evolutionTheme.typography.caption1.fontSize, _themeMapper.evolutionTheme.typography.caption1.lineHeight, _themeMapper.evolutionTheme.fontWeight.normal))));
var MatchContent = (cov_2qgp94n5nb().s[38]++, (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(function (_ref8) {
  var product = _ref8.product,
    performance = _ref8.performance,
    themeQueries = _ref8.themeQueries,
    productDescription = _ref8.productDescription;
  cov_2qgp94n5nb().f[14]++;
  cov_2qgp94n5nb().s[39]++;
  return /*#__PURE__*/_react.default.createElement(MatchWrapper, {
    flexWrap: ['wrap-reverse'],
    justify: 'baseline',
    width: 1,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 434,
      columnNumber: 5
    }
  }, /*#__PURE__*/_react.default.createElement(CustomWidth, {
    direction: 'column',
    width: "30%",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 435,
      columnNumber: 7
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 436,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react.default.createElement(MatchIndicator, {
    product: product,
    performance: performance,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 437,
      columnNumber: 11
    }
  })), ((cov_2qgp94n5nb().b[8][0]++, product.roundName) || (cov_2qgp94n5nb().b[8][1]++, themeQueries.EQUILIBRIUM)) && (cov_2qgp94n5nb().b[8][2]++, /*#__PURE__*/_react.default.createElement("span", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 439,
      columnNumber: 61
    }
  }, product.roundName)), /*#__PURE__*/_react.default.createElement(MatchDate, {
    product: product,
    performance: performance,
    showTime: true,
    showIcon: !themeQueries.EVOLUTION,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 440,
      columnNumber: 9
    }
  }), ((cov_2qgp94n5nb().b[9][0]++, performance.venue) || (cov_2qgp94n5nb().b[9][1]++, product.location)) && (cov_2qgp94n5nb().b[9][2]++, /*#__PURE__*/_react.default.createElement(MatchContentLocationWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 447,
      columnNumber: 11
    }
  }, (cov_2qgp94n5nb().b[10][0]++, !themeQueries.EVOLUTION) && (cov_2qgp94n5nb().b[10][1]++, /*#__PURE__*/_react.default.createElement(_ProductDescriptionIcon.default, {
    iconName: "map",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 448,
      columnNumber: 41
    }
  })), (cov_2qgp94n5nb().b[11][0]++, performance.venue) || (cov_2qgp94n5nb().b[11][1]++, product.location))), (cov_2qgp94n5nb().b[12][0]++, !performance.finalDate) && (cov_2qgp94n5nb().b[12][1]++, /*#__PURE__*/_react.default.createElement(_DateLabel.default, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 453,
      columnNumber: 11
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: "gravity.Product.dateToBeConfirmed",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 454,
      columnNumber: 13
    }
  })))), /*#__PURE__*/_react.default.createElement(CustomWidth, {
    justify: "center",
    width: "62%",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 459,
      columnNumber: 7
    }
  }, /*#__PURE__*/_react.default.createElement(_MatchTeamDetail.default, {
    hostTeam: performance.hostTeam,
    opposingTeam: performance.opposingTeam,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 460,
      columnNumber: 9
    }
  })), (cov_2qgp94n5nb().b[13][0]++, themeQueries.EVOLUTION) && (cov_2qgp94n5nb().b[13][1]++, /*#__PURE__*/_react.default.createElement(CustomWidth, {
    width: "100%",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 462,
      columnNumber: 34
    }
  }, productDescription)));
})));
cov_2qgp94n5nb().s[40]++;
MatchContent.propTypes = {
  /* The product object to display */
  product: _product.ProductType.isRequired,
  /* A specific performance to display, if provided take the performance data in priority */
  performance: _product.PerformanceType,
  themeContext: _themeProvider.ThemeContextType
};
cov_2qgp94n5nb().s[41]++;
MatchContent.defaultProps = {
  performance: undefined,
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT
};
var MainContent = (cov_2qgp94n5nb().s[42]++, (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(function (_ref9) {
  var product = _ref9.product,
    performance = _ref9.performance,
    timeslot = _ref9.timeslot,
    isMatch = _ref9.isMatch,
    intl = _ref9.intl,
    themeQueries = _ref9.themeQueries,
    productDescription = _ref9.productDescription;
  cov_2qgp94n5nb().f[15]++;
  cov_2qgp94n5nb().s[43]++;
  return /*#__PURE__*/_react.default.createElement(MainContentWrapper, {
    auto: true,
    p: themeQueries.EQUILIBRIUM ? (cov_2qgp94n5nb().b[14][0]++, [0, 1]) : (cov_2qgp94n5nb().b[14][1]++, [0, 0, 0, 1]),
    py: [2, 0],
    mobileWidth: themeQueries.EVOLUTION ? (cov_2qgp94n5nb().b[15][0]++, "".concat(_themeMapper.evolutionTheme.breakpoints.lg - 1, "px")) : (cov_2qgp94n5nb().b[15][1]++, undefined),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 483,
      columnNumber: 5
    }
  }, isMatch ? (cov_2qgp94n5nb().b[16][0]++, /*#__PURE__*/_react.default.createElement(MatchContent, {
    product: product,
    performance: performance,
    productDescription: productDescription,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 489,
      columnNumber: 9
    }
  })) : (cov_2qgp94n5nb().b[16][1]++, /*#__PURE__*/_react.default.createElement(ProductContent, {
    product: product,
    performance: performance,
    timeslot: timeslot,
    intl: intl,
    productDescription: productDescription,
    replaceProductNameByPerformance: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 491,
      columnNumber: 9
    }
  })));
})));
cov_2qgp94n5nb().s[44]++;
MainContent.propTypes = {
  /* The product object to display */
  product: _product.ProductType.isRequired,
  /* A specific performance to display, if provided take the performance data in priority */
  performance: _product.PerformanceType,
  /* a specific timeslot to display, if provided take the timeslotData in priority */
  timeslot: _product.TimeslotType,
  /* Display as match or normal product */
  isMatch: _propTypes.default.bool.isRequired,
  /* get the possiblity to get internationalization */
  intl: _reactIntl.intlShape.isRequired,
  replaceProductNameByPerformance: _propTypes.default.bool,
  themeContext: _themeProvider.ThemeContextType
};
cov_2qgp94n5nb().s[45]++;
MainContent.defaultProps = {
  performance: undefined,
  timeslot: undefined,
  replaceProductNameByPerformance: false,
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT
};

/** Display image of product line */
var LeftContent = (cov_2qgp94n5nb().s[46]++, (0, _themeProvider.withThemeConsumer)((0, _utils.withMediaQueries)((0, _utils.withThemeQueries)(function (_ref10) {
  var product = _ref10.product,
    performance = _ref10.performance,
    isMatch = _ref10.isMatch,
    isLandingPage = _ref10.isLandingPage,
    ecommerceGoogleTracking = _ref10.ecommerceGoogleTracking,
    productTitle = _ref10.productTitle,
    mediaQueries = _ref10.mediaQueries,
    themeQueries = _ref10.themeQueries,
    lastItemId = _ref10.lastItemId;
  cov_2qgp94n5nb().f[16]++;
  var aspectRatio = (cov_2qgp94n5nb().s[47]++, function () {
    cov_2qgp94n5nb().f[17]++;
    cov_2qgp94n5nb().s[48]++;
    if (themeQueries.EQUILIBRIUM) {
      cov_2qgp94n5nb().b[17][0]++;
      cov_2qgp94n5nb().s[49]++;
      return 'VERTICAL';
    } else {
      cov_2qgp94n5nb().b[17][1]++;
    }
    cov_2qgp94n5nb().s[50]++;
    return mediaQueries.lg ? (cov_2qgp94n5nb().b[18][0]++, 'SQUARE') : (cov_2qgp94n5nb().b[18][1]++, 'LANDSCAPE');
  }());
  cov_2qgp94n5nb().s[51]++;
  if (isMatch) {
    cov_2qgp94n5nb().b[19][0]++;
    cov_2qgp94n5nb().s[52]++;
    return /*#__PURE__*/_react.default.createElement(FixedWrapper, {
      desktopWidth: themeQueries.EQUILIBRIUM ? (cov_2qgp94n5nb().b[20][0]++, '60px') : (cov_2qgp94n5nb().b[20][1]++, '70px'),
      phoneWidth: themeQueries.EQUILIBRIUM ? (cov_2qgp94n5nb().b[21][0]++, '25%') : (cov_2qgp94n5nb().b[21][1]++, '100%'),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 551,
        columnNumber: 13
      }
    }, /*#__PURE__*/_react.default.createElement(_ProductImage.default, {
      product: product,
      performance: performance,
      aspectRatio: aspectRatio,
      tooltip: product.name,
      ecommerceGoogleTracking: ecommerceGoogleTracking,
      isLandingPage: isLandingPage,
      resizeMode: "contain",
      lastItemId: lastItemId,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 554,
        columnNumber: 15
      }
    }));
  } else {
    cov_2qgp94n5nb().b[19][1]++;
  }
  var image = (cov_2qgp94n5nb().s[53]++, /*#__PURE__*/_react.default.createElement(ImageWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 569,
      columnNumber: 11
    }
  }, /*#__PURE__*/_react.default.createElement(_ProductImage.default, {
    product: product,
    performance: performance,
    aspectRatio: "WIDE",
    tooltip: productTitle,
    ecommerceGoogleTracking: ecommerceGoogleTracking,
    isLandingPage: isLandingPage,
    lastItemId: lastItemId,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 570,
      columnNumber: 13
    }
  })));
  cov_2qgp94n5nb().s[54]++;
  if ((cov_2qgp94n5nb().b[23][0]++, product.isSoldOut) || (cov_2qgp94n5nb().b[23][1]++, product.notOnSales)) {
    cov_2qgp94n5nb().b[22][0]++;
    cov_2qgp94n5nb().s[55]++;
    image = /*#__PURE__*/_react.default.createElement(_backdrop.default, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 583,
        columnNumber: 19
      }
    }, image);
  } else {
    cov_2qgp94n5nb().b[22][1]++;
  }
  cov_2qgp94n5nb().s[56]++;
  return /*#__PURE__*/_react.default.createElement(FixedWrapper, {
    desktopWidth: "180px",
    phoneWidth: "100%",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 586,
      columnNumber: 11
    }
  }, image);
}))));
cov_2qgp94n5nb().s[57]++;
LeftContent.propTypes = {
  /* The product object to display */
  product: _product.ProductType.isRequired,
  /* A specific performance to display, if provided take the performance data in priority */
  performance: _product.PerformanceType,
  /* Display as match or normal product */
  isMatch: _propTypes.default.bool.isRequired,
  /** Indicator of current page is landing page */
  isLandingPage: _propTypes.default.bool,
  /** Option to use google enhance tracking to push data to data layer */
  productTitle: _propTypes.default.string,
  ecommerceGoogleTracking: _propTypes.default.shape({}),
  themeContext: _themeProvider.ThemeContextType,
  mediaQueries: _utils.WithMediaQueriesType,
  lastItemId: _propTypes.default.number
};
cov_2qgp94n5nb().s[58]++;
LeftContent.defaultProps = {
  performance: undefined,
  timeslot: undefined,
  isLandingPage: false,
  productTitle: null,
  ecommerceGoogleTracking: {
    useGoogleEnhancedTracking: false,
    user: {}
  },
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  mediaQueries: {},
  lastItemId: 0
};
var SoldOutLabel = (cov_2qgp94n5nb().s[59]++, (0, _styledComponents.default)(CenterText)(_templateObject32 || (_templateObject32 = (0, _taggedTemplateLiteral2.default)(["\n  color: #ff4f4f;\n"]))));
var SalesStartDate = (cov_2qgp94n5nb().s[60]++, (0, _styledComponents.default)(CenterText)(_templateObject33 || (_templateObject33 = (0, _taggedTemplateLiteral2.default)(["\n  color: gray;\n  text-transform: none;\n"]))));
cov_2qgp94n5nb().s[61]++;
var getAccessibilityTitleId = function getAccessibilityTitleId(product, performance, timeslot) {
  cov_2qgp94n5nb().f[18]++;
  cov_2qgp94n5nb().s[62]++;
  if (performance) {
    cov_2qgp94n5nb().b[24][0]++;
    cov_2qgp94n5nb().s[63]++;
    return performance.id;
  } else {
    cov_2qgp94n5nb().b[24][1]++;
  }
  cov_2qgp94n5nb().s[64]++;
  if (timeslot) {
    cov_2qgp94n5nb().b[25][0]++;
    cov_2qgp94n5nb().s[65]++;
    return timeslot.id;
  } else {
    cov_2qgp94n5nb().b[25][1]++;
  }
  cov_2qgp94n5nb().s[66]++;
  return product.id;
};
cov_2qgp94n5nb().s[67]++;
var buildStreamOnlineConfig = function buildStreamOnlineConfig(product, performance, timeslot, displayAs) {
  cov_2qgp94n5nb().f[19]++;
  var shouldDisplayWatchNow = (cov_2qgp94n5nb().s[68]++, false);
  var productId = (cov_2qgp94n5nb().s[69]++, null);
  var performanceId = (cov_2qgp94n5nb().s[70]++, null);
  var timeslotId = (cov_2qgp94n5nb().s[71]++, null);
  var buyActionUrl = (cov_2qgp94n5nb().s[72]++, null);
  var accessCode = (cov_2qgp94n5nb().s[73]++, '');
  var isAlreadyWatch = (cov_2qgp94n5nb().s[74]++, false);
  var isLoginRequired = (cov_2qgp94n5nb().s[75]++, false);
  cov_2qgp94n5nb().s[76]++;
  if ((cov_2qgp94n5nb().b[27][0]++, product.streamOnline !== undefined) && (cov_2qgp94n5nb().b[27][1]++, product.streamOnline !== null)) {
    cov_2qgp94n5nb().b[26][0]++;
    cov_2qgp94n5nb().s[77]++;
    shouldDisplayWatchNow = true;
    cov_2qgp94n5nb().s[78]++;
    if (displayAs === 'PRODUCT') {
      cov_2qgp94n5nb().b[28][0]++;
      cov_2qgp94n5nb().s[79]++;
      productId = product.id;
      cov_2qgp94n5nb().s[80]++;
      buyActionUrl = (0, _get.default)(product, 'action.buy', null);
      cov_2qgp94n5nb().s[81]++;
      accessCode = (0, _get.default)(product, 'streamOnline.streamContentValue.accessCredentials', '');
      cov_2qgp94n5nb().s[82]++;
      isAlreadyWatch = (0, _get.default)(product, 'streamOnline.alreadyWatch', false);
      cov_2qgp94n5nb().s[83]++;
      isLoginRequired = (0, _get.default)(product, 'streamOnline.publicTariffLoginRequired', false);
    } else {
      cov_2qgp94n5nb().b[28][1]++;
    }
    cov_2qgp94n5nb().s[84]++;
    if (displayAs === 'PERFORMANCE') {
      cov_2qgp94n5nb().b[29][0]++;
      cov_2qgp94n5nb().s[85]++;
      productId = product.id;
      cov_2qgp94n5nb().s[86]++;
      if (performance) {
        cov_2qgp94n5nb().b[30][0]++;
        cov_2qgp94n5nb().s[87]++;
        performanceId = performance.id;
      } else {
        cov_2qgp94n5nb().b[30][1]++;
      }
      cov_2qgp94n5nb().s[88]++;
      if (timeslot) {
        cov_2qgp94n5nb().b[31][0]++;
        cov_2qgp94n5nb().s[89]++;
        timeslotId = timeslot.id;
      } else {
        cov_2qgp94n5nb().b[31][1]++;
      }
      cov_2qgp94n5nb().s[90]++;
      buyActionUrl = performance ? (cov_2qgp94n5nb().b[32][0]++, (0, _get.default)(performance, 'action.buy', null)) : (cov_2qgp94n5nb().b[32][1]++, (0, _get.default)(timeslot, 'action.buy', null));
      cov_2qgp94n5nb().s[91]++;
      accessCode = performance ? (cov_2qgp94n5nb().b[33][0]++, (0, _get.default)(performance, 'streamOnline.streamContentValue.accessCredentials', '')) : (cov_2qgp94n5nb().b[33][1]++, (0, _get.default)(product, 'streamOnline.streamContentValue.accessCredentials', ''));
      cov_2qgp94n5nb().s[92]++;
      isAlreadyWatch = performance ? (cov_2qgp94n5nb().b[34][0]++, (0, _get.default)(performance, 'streamOnline.alreadyWatch', false)) : (cov_2qgp94n5nb().b[34][1]++, (0, _get.default)(product, 'streamOnline.alreadyWatch', false));
      cov_2qgp94n5nb().s[93]++;
      isLoginRequired = performance ? (cov_2qgp94n5nb().b[35][0]++, (0, _get.default)(performance, 'streamOnline.publicTariffLoginRequired', false)) : (cov_2qgp94n5nb().b[35][1]++, (0, _get.default)(product, 'streamOnline.publicTariffLoginRequired', false));
    } else {
      cov_2qgp94n5nb().b[29][1]++;
    }
  } else {
    cov_2qgp94n5nb().b[26][1]++;
  }
  cov_2qgp94n5nb().s[94]++;
  return {
    shouldDisplayWatchNow: shouldDisplayWatchNow,
    productId: productId,
    performanceId: performanceId,
    timeslotId: timeslotId,
    buyActionUrl: buyActionUrl,
    accessCode: accessCode,
    isAlreadyWatch: isAlreadyWatch,
    isLoginRequired: isLoginRequired
  };
};

/** Contains action button & sale start date info */
var RightContent = (cov_2qgp94n5nb().s[95]++, (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(function (_ref11) {
  var product = _ref11.product,
    performance = _ref11.performance,
    timeslot = _ref11.timeslot,
    waitingListEnabled = _ref11.waitingListEnabled,
    showPrice = _ref11.showPrice,
    currencyCode = _ref11.currencyCode,
    isMatch = _ref11.isMatch,
    onActionClick = _ref11.onActionClick,
    displayAs = _ref11.displayAs,
    onWatchStreamOnline = _ref11.onWatchStreamOnline,
    ecommerceGoogleTracking = _ref11.ecommerceGoogleTracking,
    productTitle = _ref11.productTitle,
    resaleAvailability = _ref11.resaleAvailability,
    themeQueries = _ref11.themeQueries;
  cov_2qgp94n5nb().f[20]++;
  var _ref12 = (cov_2qgp94n5nb().s[96]++, (cov_2qgp94n5nb().b[36][0]++, performance) || (cov_2qgp94n5nb().b[36][1]++, timeslot) || (cov_2qgp94n5nb().b[36][2]++, product)),
    action = _ref12.action,
    notOnSales = _ref12.notOnSales,
    restrictedAdv = _ref12.restrictedAdv,
    salesStartDate = _ref12.salesStartDate,
    salesEndDate = _ref12.salesEndDate,
    availability = _ref12.availability;
  var minAmount = (cov_2qgp94n5nb().s[97]++, (cov_2qgp94n5nb().b[37][0]++, performance) && (cov_2qgp94n5nb().b[37][1]++, performance.minAmount) || (cov_2qgp94n5nb().b[37][2]++, product) && (cov_2qgp94n5nb().b[37][3]++, product.minAmount));
  var isSoldOut = (cov_2qgp94n5nb().s[98]++, (cov_2qgp94n5nb().b[38][0]++, availability === 'NONE') && (cov_2qgp94n5nb().b[38][1]++, !notOnSales));
  var isInFutureSalesPeriod = (cov_2qgp94n5nb().s[99]++, (cov_2qgp94n5nb().b[39][0]++, notOnSales) && (cov_2qgp94n5nb().b[39][1]++, !restrictedAdv));
  var isOutOfSale = (cov_2qgp94n5nb().s[100]++, (cov_2qgp94n5nb().b[40][0]++, notOnSales) && (cov_2qgp94n5nb().b[40][1]++, (0, _utils2.isAfterSaleEnd)(salesEndDate)));
  var isAvailableOnSales = (cov_2qgp94n5nb().s[101]++, (cov_2qgp94n5nb().b[41][0]++, !isSoldOut) && (cov_2qgp94n5nb().b[41][1]++, !notOnSales));
  var isCheckResaleAvailabilityVisible = (cov_2qgp94n5nb().s[102]++, (0, _utils2.getResaleAvailabilityVisibility)(isSoldOut, resaleAvailability, product));
  var resaleURL = (cov_2qgp94n5nb().s[103]++, (0, _utils2.buildResaleURL)(product, performance, resaleAvailability));
  var buttonVariant = (cov_2qgp94n5nb().s[104]++, function () {
    cov_2qgp94n5nb().f[21]++;
    cov_2qgp94n5nb().s[105]++;
    return _button.ButtonVariant.primary;
  }());
  cov_2qgp94n5nb().s[106]++;
  var SoldOutContent = function SoldOutContent() {
    cov_2qgp94n5nb().f[22]++;
    cov_2qgp94n5nb().s[107]++;
    return /*#__PURE__*/_react.default.createElement(BoxSoldOutContent, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 732,
        columnNumber: 9
      }
    }, /*#__PURE__*/_react.default.createElement(SoldOutLabel, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 733,
        columnNumber: 11
      }
    }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
      id: 'gravity.Product.full',
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 734,
        columnNumber: 13
      }
    })), (cov_2qgp94n5nb().b[42][0]++, waitingListEnabled) && (cov_2qgp94n5nb().b[42][1]++, product.waitingListUrl) && (cov_2qgp94n5nb().b[42][2]++, /*#__PURE__*/_react.default.createElement(_ProductActions.default, {
      buttonVariant: buttonVariant,
      product: product,
      actions: {
        subscribe: product.waitingListUrl
      },
      onActionClick: onActionClick,
      accessibilityActionLabel: productTitle,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 738,
        columnNumber: 15
      }
    })), (cov_2qgp94n5nb().b[43][0]++, isCheckResaleAvailabilityVisible) && (cov_2qgp94n5nb().b[43][1]++, /*#__PURE__*/_react.default.createElement(_CheckResaleAvailability.default, {
      justifyContentDirection: "flex-start",
      onCheckResaleAvalClickHandler: function onCheckResaleAvalClickHandler() {
        cov_2qgp94n5nb().f[23]++;
        cov_2qgp94n5nb().s[108]++;
        return window.open(resaleURL, '_blank');
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 747,
        columnNumber: 13
      }
    })));
  };
  cov_2qgp94n5nb().s[109]++;
  var ComingSoonContent = function ComingSoonContent() {
    cov_2qgp94n5nb().f[24]++;
    cov_2qgp94n5nb().s[110]++;
    return /*#__PURE__*/_react.default.createElement(_gridStyled.Flex, {
      flexDirection: "column",
      column: true,
      py: 1,
      className: "stx-ComingSoonContent",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 756,
        columnNumber: 9
      }
    }, /*#__PURE__*/_react.default.createElement(CenterText, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 757,
        columnNumber: 11
      }
    }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
      id: 'gravity.Product.comingSoon',
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 758,
        columnNumber: 13
      }
    })), (cov_2qgp94n5nb().b[44][0]++, salesStartDate) && (cov_2qgp94n5nb().b[44][1]++, /*#__PURE__*/_react.default.createElement(SalesStartDate, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 761,
        columnNumber: 13
      }
    }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
      value: salesStartDate,
      weekday: "short",
      day: "numeric",
      month: "short",
      year: "numeric",
      timeZone: "UTC",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 762,
        columnNumber: 15
      }
    }))));
  };
  cov_2qgp94n5nb().s[111]++;
  var OutOfSaleContent = function OutOfSaleContent() {
    cov_2qgp94n5nb().f[25]++;
    cov_2qgp94n5nb().s[112]++;
    return /*#__PURE__*/_react.default.createElement(_gridStyled.Flex, {
      column: true,
      py: 1,
      className: "stx-OutOfSale",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 776,
        columnNumber: 9
      }
    }, /*#__PURE__*/_react.default.createElement(CenterText, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 777,
        columnNumber: 11
      }
    }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
      id: 'gravity.Product.outOfSale',
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 778,
        columnNumber: 13
      }
    })));
  };
  cov_2qgp94n5nb().s[113]++;
  var ProductLineActionButton = function ProductLineActionButton() {
    cov_2qgp94n5nb().f[26]++;
    var shouldShowPrice = (cov_2qgp94n5nb().s[114]++, (cov_2qgp94n5nb().b[45][0]++, showPrice) && (cov_2qgp94n5nb().b[45][1]++, minAmount >= 0));
    var displayAction = (cov_2qgp94n5nb().s[115]++, _objectSpread({}, action));
    var buyAction = (cov_2qgp94n5nb().s[116]++, displayAction.buy);
    var props = (cov_2qgp94n5nb().s[117]++, {
      onActionClick: onActionClick,
      product: product,
      performance: performance,
      ecommerceGoogleTracking: ecommerceGoogleTracking
    });
    var _ref13 = (cov_2qgp94n5nb().s[118]++, buildStreamOnlineConfig(product, performance, timeslot, displayAs)),
      shouldDisplayWatchNow = _ref13.shouldDisplayWatchNow,
      productId = _ref13.productId,
      performanceId = _ref13.performanceId,
      timeslotId = _ref13.timeslotId,
      buyActionUrl = _ref13.buyActionUrl,
      accessCode = _ref13.accessCode,
      isAlreadyWatch = _ref13.isAlreadyWatch,
      isLoginRequired = _ref13.isLoginRequired;

    // Show minAmount as label on buy button
    cov_2qgp94n5nb().s[119]++;
    if (shouldShowPrice) {
      cov_2qgp94n5nb().b[46][0]++;
      cov_2qgp94n5nb().s[120]++;
      // Replace by custom label button
      delete displayAction.buy;
    } else {
      cov_2qgp94n5nb().b[46][1]++;
    }
    var customMsg = (cov_2qgp94n5nb().s[121]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
      id: isMatch ? (cov_2qgp94n5nb().b[47][0]++, 'gravity.Product.ticketFrom') : (cov_2qgp94n5nb().b[47][1]++, 'gravity.Product.priceFrom'),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 806,
        columnNumber: 11
      }
    }));
    cov_2qgp94n5nb().s[122]++;
    if (shouldDisplayWatchNow) {
      cov_2qgp94n5nb().b[48][0]++;
      cov_2qgp94n5nb().s[123]++;
      return /*#__PURE__*/_react.default.createElement(_gridStyled.Box, {
        className: "stx-ProductLineActionButton",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 812,
          columnNumber: 13
        }
      }, /*#__PURE__*/_react.default.createElement(_ProductActions.default, {
        small: themeQueries.EVOLUTION,
        buttonVariant: buttonVariant,
        product: product,
        performance: performance,
        timeslot: timeslot,
        onActionClick: function onActionClick() {
          cov_2qgp94n5nb().f[27]++;
          cov_2qgp94n5nb().s[124]++;
          return onWatchStreamOnline({
            productId: productId,
            performanceId: performanceId,
            timeslotId: timeslotId
          }, buyActionUrl, isLoginRequired);
        },
        inline: true,
        ecommerceGoogleTracking: ecommerceGoogleTracking,
        actions: isAlreadyWatch ? (cov_2qgp94n5nb().b[49][0]++, {
          reWatch: (0, _get.default)(product, 'action.watchNow', '')
        }) : (cov_2qgp94n5nb().b[49][1]++, {
          watchNow: (0, _get.default)(product, 'action.watchNow', '')
        }),
        buttonNote: accessCode !== '' ? (cov_2qgp94n5nb().b[50][0]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: 'streamOnline.label.accessCode',
          values: {
            code: accessCode
          },
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 835,
            columnNumber: 21
          }
        })) : (cov_2qgp94n5nb().b[50][1]++, null),
        accessibilityActionLabel: productTitle,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 813,
          columnNumber: 15
        }
      }));
    } else {
      cov_2qgp94n5nb().b[48][1]++;
    }
    cov_2qgp94n5nb().s[125]++;
    return /*#__PURE__*/_react.default.createElement(_gridStyled.Box, {
      className: "stx-ProductLineActionButton",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 847,
        columnNumber: 11
      }
    }, (cov_2qgp94n5nb().b[51][0]++, shouldShowPrice) && (cov_2qgp94n5nb().b[51][1]++, buyAction) && (cov_2qgp94n5nb().b[51][2]++, /*#__PURE__*/_react.default.createElement(_gridStyled.Box, {
      className: "stx-RightContentButtonWrapper",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 850,
        columnNumber: 17
      }
    }, /*#__PURE__*/_react.default.createElement(RightContentButton, (0, _extends2.default)({
      variant: buttonVariant,
      small: themeQueries.EVOLUTION
    }, _ProductHelper.default.getActionHandler(props, product.id, buyAction), {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 851,
        columnNumber: 19
      }
    }), /*#__PURE__*/_react.default.createElement(_price.default, {
      currencyCode: currencyCode,
      minAmount: minAmount,
      labelFrom: customMsg,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 855,
        columnNumber: 21
      }
    }), /*#__PURE__*/_react.default.createElement(AccessibilityTitleContent, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 860,
        columnNumber: 21
      }
    }, productTitle)))), /*#__PURE__*/_react.default.createElement(_ProductActions.default, {
      buttonVariant: buttonVariant,
      product: product,
      performance: performance,
      timeslot: timeslot,
      actions: displayAction,
      onActionClick: onActionClick,
      ecommerceGoogleTracking: ecommerceGoogleTracking,
      accessibilityActionLabel: productTitle,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 864,
        columnNumber: 13
      }
    }));
  };
  cov_2qgp94n5nb().s[126]++;
  return /*#__PURE__*/_react.default.createElement(RightContentWrapper, {
    auto: true,
    direction: 'column',
    p: [0, 0],
    py: (1, 0),
    width: [1, 0.5, 0.2],
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 878,
      columnNumber: 9
    }
  }, (cov_2qgp94n5nb().b[52][0]++, isOutOfSale) && (cov_2qgp94n5nb().b[52][1]++, /*#__PURE__*/_react.default.createElement(OutOfSaleContent, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 879,
      columnNumber: 27
    }
  })), (cov_2qgp94n5nb().b[53][0]++, !isOutOfSale) && (cov_2qgp94n5nb().b[53][1]++, isInFutureSalesPeriod) && (cov_2qgp94n5nb().b[53][2]++, /*#__PURE__*/_react.default.createElement(ComingSoonContent, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 880,
      columnNumber: 53
    }
  })), (cov_2qgp94n5nb().b[54][0]++, isSoldOut) && (cov_2qgp94n5nb().b[54][1]++, /*#__PURE__*/_react.default.createElement(SoldOutContent, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 881,
      columnNumber: 25
    }
  })), (cov_2qgp94n5nb().b[55][0]++, isAvailableOnSales) && (cov_2qgp94n5nb().b[55][1]++, /*#__PURE__*/_react.default.createElement(ProductLineActionButton, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 882,
      columnNumber: 34
    }
  })));
})));
cov_2qgp94n5nb().s[127]++;
RightContent.propTypes = {
  /* The product object to display */
  product: _product.ProductType.isRequired,
  /* A specific performance to display, if provided take the performance data in priority */
  performance: _product.PerformanceType,
  /* a specific timeslot to display, if provided take the timeslotData in priority */
  timeslot: _product.TimeslotType,
  /* Need the currency code to display correctly the price  */
  currencyCode: _propTypes.default.string,
  /* Should we display the buttons to access the ts pages (buy, reserve, request, option) */
  waitingListEnabled: _propTypes.default.bool,
  /* Show product price minimum */
  showPrice: _propTypes.default.bool,
  /* Display as match or normal product */
  isMatch: _propTypes.default.bool.isRequired,
  onActionClick: _propTypes.default.func,
  displayAs: _propTypes.default.oneOf(['PRODUCT', 'PERFORMANCE', 'TOUR']),
  /** Function to handle watch stream online */
  onWatchStreamOnline: _propTypes.default.func,
  /** Option to use google enhance tracking to push data to data layer */
  ecommerceGoogleTracking: _propTypes.default.shape({}),
  /** Key to generate unique id for product title */
  keyPrefix: _propTypes.default.string,
  productTitle: _propTypes.default.string,
  resaleAvailability: _propTypes.default.shape({}),
  themeContext: _themeProvider.ThemeContextType,
  themeQueries: _utils.WithThemeQueriesType
};
cov_2qgp94n5nb().s[128]++;
RightContent.defaultProps = {
  performance: undefined,
  timeslot: undefined,
  showPrice: false,
  waitingListEnabled: false,
  currencyCode: null,
  onActionClick: null,
  displayAs: null,
  onWatchStreamOnline: null,
  ecommerceGoogleTracking: {
    useGoogleEnhancedTracking: false,
    user: {}
  },
  keyPrefix: null,
  productTitle: null,
  resaleAvailability: {},
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT
};

/*
* Component to display a product in a line
*/
cov_2qgp94n5nb().s[129]++;
var ProductLine = function ProductLine(props) {
  cov_2qgp94n5nb().f[28]++;
  var _ref14 = (cov_2qgp94n5nb().s[130]++, props),
    product = _ref14.product,
    showDescription = _ref14.showDescription,
    performance = _ref14.performance,
    timeslot = _ref14.timeslot,
    isSignedIn = _ref14.isSignedIn,
    intl = _ref14.intl,
    onActionClick = _ref14.onActionClick,
    isLandingPage = _ref14.isLandingPage,
    ecommerceGoogleTracking = _ref14.ecommerceGoogleTracking,
    displayAs = _ref14.displayAs,
    replaceProductNameByPerformance = _ref14.replaceProductNameByPerformance,
    keyPrefix = _ref14.keyPrefix,
    resaleAvailability = _ref14.resaleAvailability,
    themeQueries = _ref14.themeQueries,
    lastItemId = _ref14.lastItemId;
  var _ref15 = (cov_2qgp94n5nb().s[131]++, product),
    internetDescriptionUrl = _ref15.internetDescriptionUrl;
  function decodeHtmlString(inputString) {
    cov_2qgp94n5nb().f[29]++;
    // convert "Chris&apos;&nbsp;corner" to "Chris' corner"
    var textArea = (cov_2qgp94n5nb().s[132]++, document.createElement('textArea'));
    cov_2qgp94n5nb().s[133]++;
    textArea.innerHTML = inputString;
    cov_2qgp94n5nb().s[134]++;
    return inputString ? (cov_2qgp94n5nb().b[56][0]++, textArea.value) : (cov_2qgp94n5nb().b[56][1]++, undefined);
  }
  var restrictedAdv = (cov_2qgp94n5nb().s[135]++, _ProductHelper.default.getVariableByKey(product, performance, timeslot, null, 'restrictedAdv'));
  var description = (cov_2qgp94n5nb().s[136]++, decodeHtmlString(_ProductHelper.default.getVariableByKey(product, performance, timeslot, null, 'description')));
  var isMatch = (cov_2qgp94n5nb().s[137]++, Boolean((cov_2qgp94n5nb().b[57][0]++, product.productType === 'SPORTING_EVENT') && (cov_2qgp94n5nb().b[57][1]++, performance)));
  var titleId = (cov_2qgp94n5nb().s[138]++, getAccessibilityTitleId(product, performance, timeslot));
  var accessibilityHeadingTitle = (cov_2qgp94n5nb().s[139]++, "".concat(keyPrefix).concat(ACCESSIBILITY_TITLE_PREFIX).concat(titleId));
  var usePerformanceName = (cov_2qgp94n5nb().s[140]++, (cov_2qgp94n5nb().b[58][0]++, displayAs === 'PERFORMANCE') && (cov_2qgp94n5nb().b[58][1]++, replaceProductNameByPerformance));
  var productTitle = (cov_2qgp94n5nb().s[141]++, _ProductHelper.default.getProductTitle({
    product: product,
    performance: performance,
    intl: intl,
    usePerformanceName: usePerformanceName
  }));
  var productDescription = (cov_2qgp94n5nb().s[142]++, /*#__PURE__*/_react.default.createElement(_ProductDescription.default, {
    ariaControlId: titleId,
    describedById: accessibilityHeadingTitle,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 990,
      columnNumber: 5
    }
  }, /*#__PURE__*/_react.default.createElement(_gridStyled.Box, {
    width: 1,
    p: [1, 2],
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 991,
      columnNumber: 7
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    id: titleId,
    dangerouslySetInnerHTML: {
      __html: description
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 992,
      columnNumber: 9
    }
  }))));
  cov_2qgp94n5nb().s[143]++;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    productId: product.id,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 998,
      columnNumber: 5
    }
  }, /*#__PURE__*/_react.default.createElement(AccessibilityHeading, {
    id: accessibilityHeadingTitle,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 999,
      columnNumber: 7
    }
  }, productTitle), /*#__PURE__*/_react.default.createElement(LeftContent, {
    product: product,
    performance: performance,
    timeslot: timeslot,
    isMatch: isMatch,
    ecommerceGoogleTracking: ecommerceGoogleTracking,
    isLandingPage: isLandingPage,
    productTitle: productTitle,
    lastItemId: lastItemId,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 1000,
      columnNumber: 7
    }
  }), /*#__PURE__*/_react.default.createElement(MainContent, {
    product: product,
    performance: performance,
    timeslot: timeslot,
    isMatch: isMatch,
    intl: intl,
    replaceProductNameByPerformance: usePerformanceName,
    productDescription: (cov_2qgp94n5nb().b[59][0]++, themeQueries.EVOLUTION) && (cov_2qgp94n5nb().b[59][1]++, showDescription) && (cov_2qgp94n5nb().b[59][2]++, description) && (cov_2qgp94n5nb().b[59][3]++, productDescription),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 1010,
      columnNumber: 7
    }
  }), /*#__PURE__*/_react.default.createElement(RightContent, (0, _extends2.default)({}, props, {
    product: product,
    performance: performance,
    timeslot: timeslot,
    isMatch: isMatch,
    onActionClick: onActionClick,
    productTitle: productTitle,
    resaleAvailability: resaleAvailability,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 1020,
      columnNumber: 7
    }
  })), (cov_2qgp94n5nb().b[60][0]++, restrictedAdv) && (cov_2qgp94n5nb().b[60][1]++, /*#__PURE__*/_react.default.createElement(RestrictedAdvBox, {
    py: 1,
    width: 1,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 1031,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react.default.createElement(_gridStyled.Flex, {
    column: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 1032,
      columnNumber: 11
    }
  }, isSignedIn ? (cov_2qgp94n5nb().b[61][0]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: 'gravity.Product.restrictedOfferMsg',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 1034,
      columnNumber: 15
    }
  })) : (cov_2qgp94n5nb().b[61][1]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: 'gravity.Product.restrictedOfferMsgWithoutLogin',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 1036,
      columnNumber: 15
    }
  })), (cov_2qgp94n5nb().b[62][0]++, internetDescriptionUrl) && (cov_2qgp94n5nb().b[62][1]++, /*#__PURE__*/_react.default.createElement(_button.default, {
    small: true,
    flat: true,
    href: internetDescriptionUrl,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 1039,
      columnNumber: 15
    }
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
    id: "gravity.Product.moreInfo",
    defaultMessage: "More info",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 1040,
      columnNumber: 17
    }
  })))))), (cov_2qgp94n5nb().b[63][0]++, themeQueries.EQUILIBRIUM) && (cov_2qgp94n5nb().b[63][1]++, showDescription) && (cov_2qgp94n5nb().b[63][2]++, description) && (cov_2qgp94n5nb().b[63][3]++, productDescription), /*#__PURE__*/_react.default.createElement(_jsonMetadata.default, {
    jsonMetadata: product.jsonMetadata,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 1050,
      columnNumber: 7
    }
  }));
};
cov_2qgp94n5nb().s[144]++;
ProductLine.propTypes = {
  /* The product object to display */
  product: _product.ProductType.isRequired,
  /* Show product description */
  showDescription: _propTypes.default.bool,
  /* A specific performance to display, if provided take the performance data in priority */
  performance: _product.PerformanceType,
  /* a specific timeslot to display, if provided take the timeslotData in priority */
  timeslot: _product.TimeslotType,
  /* Identify a user signed in or not */
  isSignedIn: _propTypes.default.bool,
  /** Type definitions for react-intl, using for dynamic message */
  intl: _reactIntl.intlShape.isRequired,
  /** The function called when clicking on the product or occurence action */
  onActionClick: _propTypes.default.func,
  /** Indicator of current page is landing page */
  isLandingPage: _propTypes.default.bool,
  /** Option to use google enhance tracking to push data to data layer */
  ecommerceGoogleTracking: _propTypes.default.shape({}),
  /** Key to generate unique id for product title */
  keyPrefix: _propTypes.default.string,
  displayAs: _propTypes.default.oneOf(['PRODUCT', 'PERFORMANCE', 'TOUR']),
  replaceProductNameByPerformance: _propTypes.default.bool,
  resaleAvailability: _propTypes.default.shape({}),
  themeContext: _themeProvider.ThemeContextType,
  themeQueries: _utils.WithThemeQueriesType,
  lastItemId: _propTypes.default.number
};
cov_2qgp94n5nb().s[145]++;
ProductLine.defaultProps = {
  showPrice: false,
  showDescription: false,
  performance: undefined,
  timeslot: undefined,
  isSignedIn: false,
  onActionClick: null,
  isLandingPage: false,
  ecommerceGoogleTracking: {
    useGoogleEnhancedTracking: false,
    user: {}
  },
  keyPrefix: null,
  displayAs: null,
  replaceProductNameByPerformance: false,
  resaleAvailability: {},
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  themeQueries: {},
  lastItemId: 0
};
var _default = exports.default = (0, _reactIntl.injectIntl)((0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(ProductLine)));